import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LogoutModel from './LogoutModel';
import DocumentVerificationModal from './DocumentVerificationModal';
import { loginCredential, searchCredential, jumpSeatCredential, redirectToPageCredentials, seatIdentificationCredential, moduleAndLoginDivDisabled } from '../ReduxState';
import Header from './Header';
import { useHistory, useLocation } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import { fncAssignSearchedCheckboxes, fncMakeFlightReference, fncCheckDepartedFlight, fncPageNavigations, shortcutKeyForPage, shortcutKeys, seatBlockSSRS, assignSeatRequestForConnectingFlight, assignSeatRequestForDirectFlight, createSeatMapData, fncSeatGroupSelection, fncPassengerInformation, checkinModule, isInternationalFlight, checkPassengerStatus, haveTravelDocs, fncCheckIfTokenIsExpired, fncCheckSearchedFlightDetailsEmpty, fncFocusElementDependsOnPathLocation, getCtrlshortcutKeyForPage, shortcutKeysForPageNavigation, shortcutKeysforHumburgerMenu } from '../Utility/CommonFun.js';
import { fncCallSeatMapApi, fncAutoAssignPassengerSeats, fncUnAssignPassengerSeats, fncAssignPassengerSeats, fncGetBookingFromState, fncOverrideFee, fncSeatIdentificationApi } from '../Utility/ApiCall.js';

const selectedPassengerAndSegment = {
  "passengerKey": "",
  "segmentKey": "",
  "journeyKey": "",
  "recordLocator": "",
  "currencyCode": "",
  "unitDesignator": ""
}

const notifySuccess = (e) =>
  toast.success(e, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

  function Seats({ handleSideMenu }) {
        const [leftupdiv, setleftupdiv] = useState(false);
  
    const [triggercheck, settriggercheck] = useState(false);
         const [isEditing, setIsEditing] = useState(false);     
         const noButtonRef = useRef(null);
         const yesbutton = useRef(null);
         const okbutton = useRef(null);
         const okbutton1 = useRef(null);
         const seatAssignmentFaildOkRef = useRef(null);
         const waveReasonSelest = useRef(null);
         // 12/1/25
          const [activeIndex, setActiveIndex] = useState(0); // Track the active right child  index
         const [activeleftChildIndex, setActiveleftChildIndex] = useState(0); // Track the active left child  index
         const [focusedDiv, setFocusedDiv] = useState('left'); // 'left' or 'right' or "leftup"
         const seg_Unassign_jumpref = useRef([]); // Ref for the right up  div
         const leftDivRef = useRef(0);
            const rightSeatsDivRef = useRef([]); // Ref for the right seats div
          const [popup, setpopup] = useState(false);

         const dispatch = useDispatch();
         let history = useHistory();
         const location = useLocation();
         const [triggerModal, settriggerModal] = useState(false);
         const [show, setShow] = useState(false);
         const [showErrorPopup, setshowErrorPopup] = useState(false);
         const [showSSRSeatNotAvailableErrorPopup, setShowSSRSeatNotAvailableErrorPopup] = useState(false);
         const handleClose = () => setShow(false);
         const handleCloseshowErrorPopup = () => setshowErrorPopup(false);
         const handleSSRSeatNotAvailableErrorPopup = () => setShowSSRSeatNotAvailableErrorPopup(false);
         const handleCloseWaiveFeeModal = () =>{ setShowWaiveFeeModal(false); setFocusedDiv("left");};
         const [showWaiveFeeModal, setShowWaiveFeeModal] = useState(false);
         const [paxKeyForWaiveFee, setPaxKeyForWaiveFee] = useState(null);
         const [ShowWaveTextBox, setShowWaveTextBox] = useState(false);
         const [WaveReasonTextBox, setWaveReasonTextBox] = useState("");
         const [waveOK, setwaveOK] = useState(true);
         const handleShow = () => setShow(true);
         const UserRights = useSelector(state => state.login.CheckInRights);
         const UserBoardingRights = useSelector(state => state.login.BoardingRights);
         const stSearchedRecordData = useSelector(state => state.search.SearchedRecordData);
         const SearchedFlightDetails = useSelector(state => state.search.SearchedFlightDetails);
         const SearchedSelectedPassengerData = useSelector(state => state.selectedpassenger.SelectedPassengerData);
         const [seatmapApiData, setSeatMapApiData] = useState([]);
         const [st_AirlineHeader, setAirlineHeader] = useState([]);
         const selectedModule = useSelector(state => state.login.Module);
         const docVerified = useSelector(state => state.docVerify.documentsVerified);
         const inputElementForSeat = useRef([]);
         // debugger
         const isJumpSeatSelected = useSelector(state => state.search.isJumpSeatSelected);
         const seatIdentificationData = useSelector(state => state.seat.SeatIdentification);
         const IsModulAndLoginDivDisabled = useSelector(state => state.login.IsModulAndLoginDivDisabled);
         const [jumpSeat, setJumpSeat] = useState(isJumpSeatSelected);
         const [st_UnAssignAll, setUnAssignAll] = useState(true);
         const [jumpSeatDisabled, setJumpSeatDisabled] = useState(true);
         const [st_countOfRowsFormed, setcountOfRowsFormed] = useState([]);
         const [isSeatIdentificationCallRequired, setIsSeatIdentificationCallRequired] = useState(false);
         // const [segmentKeyForCurrentSeatmap, setSegmentKeyForCurrentSeatmap] = useState('');
         //-------------------------------------------- IMAGES FOR CHECKEDIN AND HELDFOR THIS SESSION ENDS HERE-------------------------
         // console.log('R5C4UL', st_countOfRowsFormed)
         const [st_SelectedSeatByPassenger, setSelectedPassengerSeatData] = useState({
           "passengerKey": "",
           "journeyKey": "",
           "recordLocator": "",
           "currencyCode": "",
           "unitDesignator": "",
           "segmentKey": ""
         });
       
           // console.log('st_AirlineHeader', st_AirlineHeader);
           // console.log('seat component=====', isInternationalFlight(SearchedFlightDetails), selectedModule, docVerified);
       
         const [st_UserSeatDetails, setUserSeatDetails] = useState([{
           "PassengerName": "",
           "PassengerGender": "",
           "WithORwithoutINFT": "",
           "SEATDETAIL": "",
           "Amount": "",
           "AisleOrWindow": "",
           "SeatClass": "",
           "PassengerInfo": "",
           "PassengerTypeCode": "",
           "PassengerKey": "",
           "PassengerWheelChair": "",
    "unitkey": "",
           "SelectedPassenger": false
         }])
       
         const [userInputSeat, setSeatFromUserInput] = useState('');
         const validKeysForThisShortcut = ['m', 'i', 'h', 'd'];
       
         const notify = (e) =>
           toast.error(e, {
             position: "top-right",
             autoClose: 5000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: true,
             draggable: true,
             progress: undefined,
           });
       
           let allCheckedIn = false;
       
           if (!isInternationalFlight(SearchedFlightDetails) && selectedModule === checkinModule) {
             const passengersForPnr = { ...SearchedFlightDetails };
             const passengerArr = passengersForPnr.passenger.filter(p => p.IsSelected);
             let selectedPassengers = passengerArr;
             allCheckedIn = selectedPassengers.filter(p => p.passengerKey).every(p => checkPassengerStatus(SearchedFlightDetails, SearchedSelectedPassengerData, p));
           }
       
         function fncPopupCancelClick() {
           fncNextButtonFocus();
           setShow(false);
           fncOnReloadAndOnOkPopupClick();
         }
       
         function loadSeatmapForSegment(segmentKey) {
       
           var vSearchedFlightDetails = SearchedFlightDetails;
           var RecordLocator = vSearchedFlightDetails.recordLocator;
           var currencyCode = vSearchedFlightDetails.currencyCode;
           var primaryPassengerKey = "";
           for (var i = 0; i < vSearchedFlightDetails.passenger.length; i++) {
             if (vSearchedFlightDetails.passenger[i].IsSelected == true) {
               primaryPassengerKey = vSearchedFlightDetails.passenger[i].passengerKey;
               break;
             }
           }
           var JourneyKey = "";
           var next = 0;
           var unitDesignator = "";
           for (var i = 0; i < vSearchedFlightDetails.journeys.length; i++) {
             var segments = vSearchedFlightDetails.journeys[i].segments;
             for (var j = 0; j < segments.length; j++) {
               if (segments[j].IsSelected == true) {
                 JourneyKey = vSearchedFlightDetails.journeys[i].journeyKey;
                 // segmentKey = segments[j].segmentKey;
                 next = 1;
                 break;
               }
             }
             if (next == 1) {
               break;
             }
           }
       
           for (var i = 0; i < vSearchedFlightDetails.journeys.length; i++) {
             const segments = vSearchedFlightDetails.journeys[i].segments;
             for (var j = 0; j < segments.length; j++) {
               if (segments[j].IsSelected == true) {
                 var PassengerSegment = segments[j].passengerSegment;
                 for (var k = 0; k < PassengerSegment.length; k++) {
                   if (PassengerSegment[k].seats.length != 0 && primaryPassengerKey == PassengerSegment[k].passengerKey) {
                     unitDesignator = PassengerSegment[k].seats[0].unitDesignator;
                   }
                 }
               }
             }
           }
           selectedPassengerAndSegment.segmentKey = segmentKey;
           selectedPassengerAndSegment.passengerKey = primaryPassengerKey;
           selectedPassengerAndSegment.journeyKey = JourneyKey
           selectedPassengerAndSegment.recordLocator = RecordLocator
           selectedPassengerAndSegment.currencyCode = currencyCode
           selectedPassengerAndSegment.unitDesignator = unitDesignator;
       
       
           setSelectedPassengerSeatData({
             "passengerKey": primaryPassengerKey,
             "journeyKey": JourneyKey,
             "recordLocator": RecordLocator,
             "currencyCode": currencyCode,
             "unitDesignator": unitDesignator,
             "segmentKey": segmentKey
           });
           fncLoadSeatMapWithDetailsNew(segmentKey, RecordLocator, "");
       
         }
       
         function fncNextButtonFocus() {
          document.getElementById("btnNextButtonSeat").focus();
         }

         useEffect(() => {
          if (fncCheckSearchedFlightDetailsEmpty(SearchedFlightDetails)) {
              history.push('/Search');
          }
        });
    
       
         useEffect(() => {     

           // debugger
           if (st_SelectedSeatByPassenger.unitDesignator) {
             const rowId = st_SelectedSeatByPassenger.unitDesignator.slice(0, -1);
             const targetId = document.getElementById(`seatRow-${rowId}`);
             if (targetId) {
               targetId.scrollIntoView();
             }
       
           }
         }, [st_SelectedSeatByPassenger, st_countOfRowsFormed.length])
  
        //  useEffect(() => {
        //   document.addEventListener("keydown", function (event) {
        //     console.log('event in seat event.key', event.key)
        //    //  debugger
        //    console.log('userInputSeat', userInputSeat);
        //    if (event.key === 'Enter' && userInputSeat !== '' && userInputSeat.length > 1) {
        //       console.log('userInputSeat', userInputSeat);
        //      const seatrow = userInputSeat.substring(0, userInputSeat.length - 1);
        //      console.log('seatrow', seatrow);
        //      const seatRowData = st_countOfRowsFormed.find(r => r.id == seatrow);
        //      if (!seatRowData) {
        //       console.error(`No matching row found for id: ${seatrow}`);
        //       return; // Exit if no match is found
        //     }
        //      const SeatData = seatRowData && seatRowData.dataToBind.find(r => r.SeatDesignator === userInputSeat.toUpperCase());
        //      fncSeatSelection(SeatData, "SEATMAP", seatRowData.id)
        //    }
            
        //    })
  
        //    // Clean up the event listener when the component unmounts
        //    return () => {
        //     document.removeEventListener("keydown", () => {});
        //   };
         
        //  },[userInputSeat])
       
             
        // Only focus when `popup` is true and changes
         useEffect(() => {
           if (popup) {
             // setFocusedDiv("");
            //  inputElementForSeat.current[activeleftChildIndex]?.focus();
           } else {
             if (inputElementForSeat.current.length > 0) {
               inputElementForSeat.current[activeleftChildIndex]?.focus();
             }
           }
         },[popup,activeleftChildIndex])
       
         /** effect for opening/closing side menu using shortcut keys (ALT + e)  */
         useEffect(() => {
          //  debugger
           document.addEventListener("keydown", function (event) {  
             if (event.altKey && (event.key === 'Dead' || event.key === 'e')) {
               handleSideMenu();
             }
           })
         });
       
         useEffect(() => {
           debugger
           fncNextButtonFocus();     
           if (SearchedFlightDetails != undefined) {
             SearchedFlightDetails.journeys.forEach(j => {
               if (j.segments[0].classOfService.toUpperCase() === 'Z' || j.segments[0].productClass.toUpperCase() === 'ZD') {
                 setJumpSeatDisabled(false);
               }
             });
             var isPopUpOpen = true;
             var vSearchedFlightDetails = SearchedFlightDetails;
       
             for (var i = 0; i < vSearchedFlightDetails.passenger.length; i++) {
       
               if (vSearchedFlightDetails.passenger[i].IsSelected == true) {
                 for (var j = 0; j < vSearchedFlightDetails.journeys.length; j++) {
       
                   var Segments = vSearchedFlightDetails.journeys[j].segments;
                   for (var k = 0; k < Segments.length; k++) {
       
                     if (Segments[k].IsSelected) {
                       const passSeg = Segments[k].passengerSegment.filter(pseg => pseg.IsSelected);
                       for (var l = 0; l < passSeg.length; l++) {
       
                         if (passSeg[l].seats.length > 0) {
                           isPopUpOpen = false;
                         }
                         if (passSeg[l].hasInfant || passSeg[l].ssrs.filter(ssr => seatBlockSSRS.includes(ssr.ssrCode)).length > 0) {
                           setIsSeatIdentificationCallRequired(true);
                           break;
                         }
                       }
                     }
                   }
                 }
               }
             }
             if (isPopUpOpen == true) {
               setShow(isPopUpOpen);
               setUnAssignAll(true);
             }
             else {
               debugger;
               fncOnReloadAndOnOkPopupClick();
               setUnAssignAll(false);
             }
       
           }   
       
         }, []);
       
 useEffect(() => {
          // debugger
          if (isSeatIdentificationCallRequired) {
            const journeys = SearchedFlightDetails.journeys;
            const requestParam = [];
      
            journeys.forEach(j => {
              const segments = j.segments.filter(seg => seg.IsSelected);
              segments.forEach(seg => {
                seg.legs.forEach(leg => {
                  requestParam.push({
                    legkey: leg.legKey
                  })
                })
              })
            });
      
            fncSeatIdentificationApi(requestParam)
              .then((returnVal) => {
      
                document.getElementById("showAndHideSpinner").style.display = "block";
                if (returnVal.status == "401" && returnVal.data == "") {
                  document.getElementById("showAndHideSpinner").style.display = "none";
                  // notify(returnVal.statusText);
                  settriggerModal(true);
                } else {
                  if (!returnVal.data.isError) {
                    // console.log('return val for seat identification, ', returnVal.data);
                    dispatch(seatIdentificationCredential(
                      {
                        type: "",
                        SeatIdentification: returnVal.data.flightmanifest
                      }
                    ));
                    document.getElementById("showAndHideSpinner").style.display = "none";
                  } else {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    notify(returnVal.data.errorDetail.errorMessage);
                  }
                }
              })
              .catch(err => console.log("Axios err: ", err));
      
          }
        }, [isSeatIdentificationCallRequired, SearchedFlightDetails]);

 useEffect(() => {
           document.addEventListener("keydown", shortcutKeyHandler);
           return () => {
               document.removeEventListener('keydown', shortcutKeyHandler);
           };
       });
   
       const shortcutKeyHandler = (event) => {
           const tag = event.target.tagName.toLowerCase();
           const isTypingField = tag === 'input' || tag === 'textarea' || event.target.isContentEditable;
           if(shortcutKeysForPageNavigation.includes(event.key)){
               const path = shortcutKeyForPage(location.pathname, event, SearchedFlightDetails);
               if (path) {
                   history.push('/' + path);
               }
           }
           if (isTypingField && !event.ctrlKey) return;
           if (event.ctrlKey  && shortcutKeys.includes(event.key)) {
               if (shortcutKeysforHumburgerMenu.includes(event.key)) {
                       dispatch(redirectToPageCredentials(
                                   {
                                     type: "",
                                     redirectionPage: location.pathname
                                   }
                        ));
               }
               const path = shortcutKeyForPage(location.pathname, event);
               if (path) {
                   history.push('/' + path);
               }
           }                          
       }
         
         function fncOnReloadAndOnOkPopupClick() {
       
    fncNextButtonFocus();
    debugger;
           var vSearchedFlightDetails = SearchedFlightDetails;
           var RecordLocator = vSearchedFlightDetails.recordLocator;
           var currencyCode = vSearchedFlightDetails.currencyCode;
           var primaryPassengerKey = "";
       
           for (var i = 0; i < vSearchedFlightDetails.passenger.length; i++) {
             if (vSearchedFlightDetails.passenger[i].IsSelected == true) {
               primaryPassengerKey = vSearchedFlightDetails.passenger[i].passengerKey;
               break;
             }
           }
       
           var JourneyKey = "";
           var next = 0;
           var segmentKey = "";
           var unitDesignator = "";
       
           for (var i = 0; i < vSearchedFlightDetails.journeys.length; i++) {
             var segments = vSearchedFlightDetails.journeys[i].segments;
             for (var j = 0; j < segments.length; j++) {
               if (segments[j].IsSelected == true) {
                 JourneyKey = vSearchedFlightDetails.journeys[i].journeyKey;
                 segmentKey = segments[j].segmentKey;
                 next = 1;
                 break;
               }
             }
             if (next == 1) {
               break;
             }
           }
       
           for (var i = 0; i < vSearchedFlightDetails.journeys.length; i++) {
             var segments = vSearchedFlightDetails.journeys[i].segments;
             for (var j = 0; j < segments.length; j++) {
               if (segments[j].IsSelected == true) {
                 var PassengerSegment = segments[j].passengerSegment;
                 for (var k = 0; k < PassengerSegment.length; k++) {
                   if (PassengerSegment[k].seats.length != 0 && primaryPassengerKey == PassengerSegment[k].passengerKey) {
                     unitDesignator = PassengerSegment[k].seats[0].unitDesignator;
                   }
                 }
               }
             }
           }
           selectedPassengerAndSegment.segmentKey = segmentKey;
           selectedPassengerAndSegment.passengerKey = primaryPassengerKey;
           selectedPassengerAndSegment.journeyKey = JourneyKey
           selectedPassengerAndSegment.recordLocator = RecordLocator
           selectedPassengerAndSegment.currencyCode = currencyCode
           selectedPassengerAndSegment.unitDesignator = unitDesignator;
       
       
           setSelectedPassengerSeatData({
             "passengerKey": primaryPassengerKey,
             "journeyKey": JourneyKey,
             "recordLocator": RecordLocator,
             "currencyCode": currencyCode,
             "unitDesignator": unitDesignator,
             "segmentKey": segmentKey
           });
           fncLoadSeatMapWithDetailsNew(segmentKey, RecordLocator, "");
         }
       
         function fncSeatSelection(seatData, SEATMAP, dataId) {
    // console.log('seatData, SEATMAP, dataId,', seatData, SEATMAP, dataId, 'st_countOfRowsFormed', st_countOfRowsFormed)
          fncNextButtonFocus();
          // debugger
          if (seatIdentificationData.length > 0) {
            const { journeyKey, segmentKey, passengerKey } = selectedPassengerAndSegment;
            const selectedJourney = SearchedFlightDetails.journeys.filter(j => j.journeyKey === journeyKey);
            const selectedSeg = selectedJourney[0].segments.filter(s => s.segmentKey === segmentKey && s.IsSelected);
            if (selectedSeg.length > 0) {
              let ssrLeg = [];
              let allSSRBlockedSeats = [];
              selectedSeg[0].legs.forEach(leg => {
                ssrLeg = seatIdentificationData.filter(si => si.legkey === leg.legKey);
      
              })
              ssrLeg.forEach(s => {
                allSSRBlockedSeats.push(...s.rownoInfant, ...s.rownoUNMR, ...s.rownoWheelchair);
              });
      
              if (allSSRBlockedSeats.length) {
                const pseg = selectedSeg[0].passengerSegment.filter(pseg => pseg.IsSelected && pseg.passengerKey === passengerKey);
                if (pseg.length > 0 && (pseg[0].hasInfant || pseg[0].ssrs.filter(ssr => seatBlockSSRS.includes(ssr.ssrCode)).length > 0)) {
                  const blockedRows = allSSRBlockedSeats.map(i => i = i.replace(/\D/g, ''));
                  const currentSeatPickedInRow = seatData.SeatDesignator.replace(/\D/g, '');
                  if (blockedRows.includes(currentSeatPickedInRow)) {
                    setShowSSRSeatNotAvailableErrorPopup(true);
                    return;
                  }
                }
              }
            }
          }
          var departureStatus = fncCheckDepartedFlight(SearchedFlightDetails, selectedPassengerAndSegment.segmentKey);
          if (!departureStatus[0]) {
            // myRef.current.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
            var vSearchedFlightDetails = SearchedFlightDetails.journeys;
      
            const Token = localStorage.getItem("LoginToken");
            var UnassignSeats = [];
      
            const segmentKey = selectedPassengerAndSegment.segmentKey;
      
            for (var i = 0; i < vSearchedFlightDetails.length; i++) {
              var segments = vSearchedFlightDetails[i].segments.filter(seg => seg.IsSelected);
              for (var j = 0; j < segments.length; j++) {
                var passSeg = segments[j].passengerSegment;
                for (var k = 0; k < passSeg.length; k++) {
                  if (passSeg[k].IsSelected == true && segments[j].segmentKey == segmentKey
                    && passSeg[k].passengerKey == selectedPassengerAndSegment.passengerKey) {
                    UnassignSeats.push({
                      "recordlocator": SearchedFlightDetails.recordLocator,
                      "passengerKey": passSeg[k].passengerKey,
                      // "signature" : Token,
                      "unitKey": passSeg[k].seats.length > 0 ? passSeg[k].seats[0].unitKey : "",
                      "waiveFee": false,
                      "ignoreSeatSsrs": true,
                      "Mode": 'CheckedIn'
                    })
                  }
                }
              }
            }
      
      
      if (UnassignSeats[0].unitKey == "") {
              const IsAutoAssign = false;
              const AutoAssignSeatRequest = null;
              const AssignSeatRequests = [];
              AssignSeatRequests.push({
                "passengerKey": st_SelectedSeatByPassenger.passengerKey,
                // "signature" : localStorage.getItem("LoginToken"),
                "JourneyKey": st_SelectedSeatByPassenger.journeyKey,
                "unitKey": seatData.UnitKey,
                "waiveFee": false,
                "SegmentKey": st_SelectedSeatByPassenger.segmentKey,
                "RecordLocator": st_SelectedSeatByPassenger.recordLocator,
                "collectedCurrencyCode": st_SelectedSeatByPassenger.currencyCode,
                "ignoreSeatSsrs": true
              });
      
              if (seatData.Status === "Open") {
                const selectedJourney = SearchedFlightDetails.journeys.filter(j => j.journeyKey === st_SelectedSeatByPassenger.journeyKey);
                const selectedSegments = selectedJourney[0].segments.filter(seg => seg.IsSelected);
                if (selectedJourney.length && selectedSegments.length > 1) {
                  const seatMapForSegment = selectedSegments.filter(s => s.segmentKey !== segmentKey);
                  fncCallSeatMapApi(seatMapForSegment[0].segmentKey, checkinModule) //selectedJourney[0].segments[selectedJourney[0].segments.length - 1].segmentKey)
                    .then((seatMapResponse) => {
                      document.getElementById("showAndHideSpinner").style.display = "block";
                      // if ((returnVal.status == "401" && returnVal.data == "") || (returnVal.status == "500"))
                      if (seatMapResponse.status == "401" && seatMapResponse.data == "") {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        // notify(returnVal.statusText);
                        settriggerModal(true);
                      } else {
                        debugger
                        if (!seatMapResponse.data.isError) {
                          const seatMapData = createSeatMapData(seatMapResponse, SearchedFlightDetails, selectedJourney[0].segments[selectedJourney[0].segments.length - 1].segmentKey);
                          const connectingFlightData = [
                            {
                              segmentKey: st_SelectedSeatByPassenger.segmentKey,
                              seatData: seatData,
                              seatMap: st_countOfRowsFormed,
                              dataId: dataId,
                              AssignSeatRequests: AssignSeatRequests
                            }
                          ]
                          const rowID = seatData.SeatDesignator.substring(0, (seatData.SeatDesignator.length -1))
                          const seatDataRowForSecondSegment = seatMapData.filter(s => s.id == rowID);
                          const seatDataForSecondSegment = seatDataRowForSecondSegment[0].dataToBind.filter(d => d.SeatDesignator === seatData.SeatDesignator && d.Status === 'Open');
                          if (seatDataForSecondSegment.length) {
                            connectingFlightData.push({
                              segmentKey: selectedJourney[0].segments[selectedJourney[0].segments.length - 1].segmentKey,
                              seatData: seatDataForSecondSegment[0],
                              seatMap: seatMapData,
                              dataId: dataId,
                              AssignSeatRequests: [{
                                "passengerKey": st_SelectedSeatByPassenger.passengerKey,
                                "JourneyKey": st_SelectedSeatByPassenger.journeyKey,
                                "unitKey": seatDataForSecondSegment[0].UnitKey,
                                "waiveFee": false,
                                "SegmentKey": selectedJourney[0].segments[selectedJourney[0].segments.length - 1].segmentKey,
                                "RecordLocator": st_SelectedSeatByPassenger.recordLocator,
                                "collectedCurrencyCode": st_SelectedSeatByPassenger.currencyCode,
                                "ignoreSeatSsrs": true
                              }]
                            });
                          } else {
                            connectingFlightData.push({
                              segmentKey: selectedJourney[0].segments[selectedJourney[0].segments.length - 1].segmentKey,
                              seatData: seatData,
                              seatMap: seatMapData,
                              dataId: dataId,
                              AssignSeatRequests: []
                            })
                          }
                          // console.log('second segment seat data--', seatMapData);
                          const request = assignSeatRequestForConnectingFlight(connectingFlightData, st_SelectedSeatByPassenger, seatIdentificationData, SearchedFlightDetails);
                          
                          debugger
                          // const seats = seatMapResponse.data.seatMapResponse.seatMap.decks[0].compartments[0].units;
                          // const selectedSeatForFirstSegment = seats.filter(s => s.availability === 'Open' && s.designator === seatData.SeatDesignator);
                          // if (selectedSeatForFirstSegment && selectedSeatForFirstSegment.length) {
                          const IsAutoAssign = false;
                          const AutoAssignSeatRequest = null;
                          // AssignSeatRequests.push(
                          //   {
                          //     "passengerKey": st_SelectedSeatByPassenger.passengerKey,
                          //     // "signature" : localStorage.getItem("LoginToken"),
                          //     "JourneyKey": st_SelectedSeatByPassenger.journeyKey,
                          //     "unitKey": selectedSeatForFirstSegment[0].unitKey,
                          //     "SegmentKey": selectedJourney[0].segments[selectedJourney[0].segments.length - 1].segmentKey,
                          //     "waiveFee": false,
                          //     "RecordLocator": st_SelectedSeatByPassenger.recordLocator,
                          //     "collectedCurrencyCode": st_SelectedSeatByPassenger.currencyCode,
                          //     "ignoreSeatSsrs": true
                          //   }
                          // );
                          fncAssignPassengerSeats({ IsAutoAssign, AutoAssignSeatRequest, AssignSeatRequests: request, Mode:'CheckedIn' })
                            .then((returnVal) => {
                              // if ((returnVal.status == "401" && returnVal.data == "") || (returnVal.status == "500"))
                              if (returnVal.status == "401" && returnVal.data == "") {
                                document.getElementById("showAndHideSpinner").style.display = "none";
                                // notify(returnVal.statusText);
                                settriggerModal(true);
                              }
                              else {
                                document.getElementById("showAndHideSpinner").style.display = "none";
                                if (returnVal.data.isError == false) {
                                  setUnAssignAll(false);
                                  // const passengers = SearchedFlightDetails.passenger.filter(p => p.IsSelected);
                                  // const otherPassengers = passengers.filter(pax => pax.passengerKey !== st_SelectedSeatByPassenger.passengerKey);
                                  // if (passengers.length > 1) {
                                  //   const autoAssignRequestForOtherPassengers = [];
                                  //   const seatedNearPrimary = otherPassengers.map((op) => {
                                  //     return {
                                  //       passengerKey: op.passengerKey
                                  //     }
                                  //   });
                                  //   selectedSegments.forEach((sSeg) => {
                                  //     autoAssignRequestForOtherPassengers.push({
                                  //       "primaryPassengerKey": otherPassengers[0].passengerKey,
                                  //       "SegmentKey": sSeg.segmentKey,        
                                  //       "JourneyKey": st_SelectedSeatByPassenger.journeyKey,
                                  //       "waiveFee": false,
                                  //       "RecordLocator": SearchedFlightDetails.recordLocator,
                                  //       "seatedNearPrimary": seatedNearPrimary
                                  //     })
                                  //   });
                                  //   fncAutoAssignPassengerSeats(true, autoAssignRequestForOtherPassengers)
                                  //   .then((rValue) => {
                                  //     if (rValue.status == "401" && rValue.data == "") {
                                  //       document.getElementById("showAndHideSpinner").style.display = "none";
                                  //       // notify(returnVal.statusText);
                                  //       settriggerModal(true);
                                  //     } else {
                                  //       document.getElementById("showAndHideSpinner").style.display = "none";
                                  //       if (returnVal.data.isError === false) {
                                  //         fncSearchApiCallForSeat(st_SelectedSeatByPassenger.recordLocator, "RELOAD", "");
                                  //       } else {
                                  //         document.getElementById("showAndHideSpinner").style.display = "none";
                                  //         notify(returnVal.data.errorDetail.errorMessage);
                                  //       }
                                  //     }
                                  //   })
                                  //   .catch(err => console.log("Axios err: ", err))
                                  // } else {
                                  fncSearchApiCallForSeat(st_SelectedSeatByPassenger.recordLocator, "RELOAD", "");
                                  // }
                                }
                                else {
                                  document.getElementById("showAndHideSpinner").style.display = "none";
                            if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                    settriggerModal(true);
                            } else {
                                  notify(returnVal.data.errorDetail.errorMessage);
                            }
                                }
                              }
      
                            })
                            .catch(err => console.log("Axios err: ", err))
                          // } else {
                          //   const AutoAssignSeatRequestArr = [];
                          //   AutoAssignSeatRequestArr.push({
                          //     "primaryPassengerKey": st_SelectedSeatByPassenger.passengerKey,
                          //     "SegmentKey": selectedJourney[0].segments[selectedJourney[0].segments.length - 1].segmentKey,        
                          //     "JourneyKey": st_SelectedSeatByPassenger.journeyKey,
                          //     "waiveFee": false,
                          //     "RecordLocator": SearchedFlightDetails.recordLocator,
                          //     "seatedNearPrimary": []
                          //   })
                          //   const passengers = SearchedFlightDetails.passenger.filter(p => p.IsSelected);
                          //   const otherPassengers = passengers.filter(pax => pax.passengerKey !== st_SelectedSeatByPassenger.passengerKey);
                          //   if (passengers.length > 1) {
                          //     const seatedNearPrimary = otherPassengers.map((op) => {
                          //       return {
                          //         passengerKey: op.passengerKey
                          //       }
                          //     });
                          //     selectedSegments.forEach(sSeg =>
                          //       otherPassengers.forEach(op =>
                          //         AutoAssignSeatRequestArr.push({
                          //           "primaryPassengerKey": op.passengerKey,
                          //           "SegmentKey": sSeg.segmentKey,        
                          //           "JourneyKey": st_SelectedSeatByPassenger.journeyKey,
                          //           "waiveFee": false,
                          //           "RecordLocator": SearchedFlightDetails.recordLocator,
                          //           "seatedNearPrimary": seatedNearPrimary
                          //         })
                          //         )
                          //     );
      
                          //   }
                          //   fncAutoAssignPassengerSeats(true, AutoAssignSeatRequestArr)
                          //   // fncAutoAssignPassengerSeats(true, st_SelectedSeatByPassenger.passengerKey, st_SelectedSeatByPassenger.journeyKey, false, SearchedFlightDetails.recordLocator, [], selectedJourney[0].segments[selectedJourney[0].segments.length - 1].segmentKey)
                          //     .then((returnVal) => {
                          //       // debugger;
                          //       if (returnVal.status == "401" && returnVal.data == "") {
                          //         document.getElementById("showAndHideSpinner").style.display = "none";
                          //         settriggerModal(true);
                          //       }
                          //       else {
                          //         document.getElementById("showAndHideSpinner").style.display = "none";
                          //         if (returnVal.data.isError == false) {
                          //           fncAssignPassengerSeats({ IsAutoAssign, AutoAssignSeatRequest, AssignSeatRequests })
                          //             .then((returnVal) => {
                          //               // if ((returnVal.status == "401" && returnVal.data == "") || (returnVal.status == "500"))
                          //               if (returnVal.status == "401" && returnVal.data == "") {
                          //                 document.getElementById("showAndHideSpinner").style.display = "none";
                          //                 // notify(returnVal.statusText);
                          //                 settriggerModal(true);
                          //               }
                          //               else {
                          //                 document.getElementById("showAndHideSpinner").style.display = "none";
                          //                 if (returnVal.data.isError == false) {
                          //                   setUnAssignAll(false);
                          //                   fncSearchApiCallForSeat(st_SelectedSeatByPassenger.recordLocator, "RELOAD", "")
                          //                 }
                          //                 else {
                          //                   document.getElementById("showAndHideSpinner").style.display = "none";
                          //                   notify(returnVal.data.errorDetail.errorMessage);
                          //                 }
                          //               }
      
                          //             })
                          //             .catch(err => console.log("Axios err: ", err))
                          //         }
                          //         else {
                          //           setShow(false);
                          //           document.getElementById("showAndHideSpinner").style.display = "none";
                          //           notify(returnVal.data.errorDetail.errorMessage);
                          //         }
                          //       }
      
                          //     })
                          //     .catch(err => console.log("Axios err: ", err))
                          // }
                        } else {
                          document.getElementById("showAndHideSpinner").style.display = "none";
                          notify(seatMapResponse.data.errorDetail.errorMessage);
                        }
                      }
                    })
                    .catch(err => console.log("Axios err in second segment seatmap call: ", err))
                } else {
                  const request = assignSeatRequestForDirectFlight(seatData, dataId, IsAutoAssign, AutoAssignSeatRequest, AssignSeatRequests, st_countOfRowsFormed, segmentKey, st_SelectedSeatByPassenger, seatIdentificationData, SearchedFlightDetails);
                  fncAssignPassengerSeats({ IsAutoAssign, AutoAssignSeatRequest, AssignSeatRequests: request, Mode:'CheckedIn' })
                    .then((returnVal) => {
                      // if ((returnVal.status == "401" && returnVal.data == "") || (returnVal.status == "500"))
                      if (returnVal.status == "401" && returnVal.data == "") {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        // notify(returnVal.statusText);
                        settriggerModal(true);
                      }
                      else {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        if (returnVal.data.isError == false) {
                          setUnAssignAll(false);
                          // const passengers = SearchedFlightDetails.passenger.filter(p => p.IsSelected);
                          //   const otherPassengers = passengers.filter(pax => pax.passengerKey !== st_SelectedSeatByPassenger.passengerKey);
                          // if (selectedJourney.length && selectedSegments.length === 1 && passengers.length > 1) {                  
                          //     const seatedNearPrimary = otherPassengers.map((op) => {
                          //       return {
                          //         passengerKey: op.passengerKey
                          //       }
                          //     });
                          //     const autoAssignRequestForOtherPassengers = [];
                          //     autoAssignRequestForOtherPassengers.push({
                          //       "primaryPassengerKey": otherPassengers[0].passengerKey,
                          //       "SegmentKey": selectedSegments[0].segmentKey,        
                          //       "JourneyKey": st_SelectedSeatByPassenger.journeyKey,
                          //       "waiveFee": false,
                          //       "RecordLocator": SearchedFlightDetails.recordLocator,
                          //       "seatedNearPrimary": seatedNearPrimary
                          //     })
                          //     fncAutoAssignPassengerSeats(true, autoAssignRequestForOtherPassengers)
                          //     .then((rValue) => {
                          //       if (rValue.status == "401" && rValue.data == "") {
                          //         document.getElementById("showAndHideSpinner").style.display = "none";
                          //         // notify(returnVal.statusText);
                          //         settriggerModal(true);
                          //       } else {
                          //         document.getElementById("showAndHideSpinner").style.display = "none";
                          //         if (returnVal.data.isError === false) {
                          //           fncSearchApiCallForSeat(st_SelectedSeatByPassenger.recordLocator, "RELOAD", "");
                          //         } else {
                          //           document.getElementById("showAndHideSpinner").style.display = "none";
                          //           notify(returnVal.data.errorDetail.errorMessage);
                          //         }
                          //       }
                          //     })
                          //     .catch(err => console.log("Axios err: ", err))
      
                          // } else {
                          fncSearchApiCallForSeat(st_SelectedSeatByPassenger.recordLocator, "RELOAD", "");
                          // }
                        }
                        else {
                          document.getElementById("showAndHideSpinner").style.display = "none";
                    if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                            settriggerModal(true);
                    } else {
                          notify(returnVal.data.errorDetail.errorMessage);
                    }
                        }
                      }
      
                    })
                    .catch(err => console.log("Axios err: ", err))
                }
              }
              // ------------------------------------------------------------- ASSIGN API CALL IN CASE OF NO SEAT SELECTED --------------------------
              // ------------------------------------------------------------- ASSIGN API CALL --------------------------
      
            }
            else {
      
              // const assignPassengerSeats = []
              fncUnAssignPassengerSeats(UnassignSeats)
                .then((returnVal) => {
      
                  // if ((returnVal.status == "401" && returnVal.data == "") || (returnVal.status == "500"))
                  if (returnVal.status == "401" && returnVal.data == "") {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    // notify(returnVal.statusText);
                    settriggerModal(true);
                  }
                  else {
                    // document.getElementById("showAndHideSpinner").style.display="none";
                    if (returnVal.data.isError == false) {
      
                      // ------------------------------------------------------------- ASSIGN API CALL --------------------------
                      var IsAutoAssign = false;
                      var AutoAssignSeatRequest = null;
                      var AssignSeatRequests = [
                        {
                          "passengerKey": st_SelectedSeatByPassenger.passengerKey,
                          // "signature" : localStorage.getItem("LoginToken"),
                          "JourneyKey": st_SelectedSeatByPassenger.journeyKey,
                          "unitKey": seatData.UnitKey,
                          "waiveFee": false,
                          "RecordLocator": st_SelectedSeatByPassenger.recordLocator,
                          "collectedCurrencyCode": st_SelectedSeatByPassenger.currencyCode,
                          "ignoreSeatSsrs": true
                        }
                      ];
                      // assignPassengerSeats.push({IsAutoAssign, AutoAssignSeatRequest, AssignSeatRequests})
      
                      fncAssignPassengerSeats({ IsAutoAssign, AutoAssignSeatRequest, AssignSeatRequests, Mode:'CheckedIn' })
                        .then((returnVal) => {
                          // if ((returnVal.status == "401" && returnVal.data == "") || (returnVal.status == "500"))
                          if (returnVal.status == "401" && returnVal.data == "") {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            // notify(returnVal.statusText);
                            settriggerModal(true);
                          }
                          else {
      
                            // document.getElementById("showAndHideSpinner").style.display="none";
                            if (returnVal.data.isError == false) {
                              setUnAssignAll(false);
                              fncSearchApiCallForSeat(st_SelectedSeatByPassenger.recordLocator, "RELOAD")
                            }
                            else {
                              document.getElementById("showAndHideSpinner").style.display = "none";
                              notify(returnVal.data.errorDetail.errorMessage);
                            }
                          }
      
                        })
                        .catch(err => console.log("Axios err: ", err))
      
      
                      // ------------------------------------------------------------- ASSIGN API CALL --------------------------
                    }
                    else {
                      document.getElementById("showAndHideSpinner").style.display = "none";
                if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                        settriggerModal(true);
                } else {
                      notify(returnVal.data.errorDetail.errorMessage);
                }
                    }
                  }
                })
                .catch(err => console.log("Axios err: ", err))
            }
          }
          else {
            //modal popup displaying 
            setshowErrorPopup(true);
          }
        }
      
         function fncUnAssignAllSeats() {
       
    fncNextButtonFocus();
           var departureStatus = fncCheckDepartedFlight(SearchedFlightDetails, selectedPassengerAndSegment.segmentKey);
           if (departureStatus[0] == false) {
             var vSearchedFlightDetails = SearchedFlightDetails.journeys;
             var Token = localStorage.getItem("LoginToken");
             var UnassignSeats = [];
       
             for (var i = 0; i < vSearchedFlightDetails.length; i++) {
               var segments = vSearchedFlightDetails[i].segments;
               for (var j = 0; j < segments.length; j++) {
                 if (segments[j].IsSelected == true) {
                   var passSeg = segments[j].passengerSegment;
                   for (var k = 0; k < passSeg.length; k++) {
                     if (passSeg[k].IsSelected == true && passSeg[k].seats.length > 0) {
                       UnassignSeats.push({
                         "recordlocator": SearchedFlightDetails.recordLocator,
                         "passengerKey": passSeg[k].passengerKey,
                         // "signature" : Token,
                         "unitKey": passSeg[k].seats.length > 0 ? passSeg[k].seats[0].unitKey : "",
                         "waiveFee": false,
                         "ignoreSeatSsrs": true,
                         "Mode": 'CheckedIn'
                       })
                     }
                   }
                 }
               }
             }
       
             // var unsetData = st_UserSeatDetails;
       
             fncUnAssignPassengerSeats(UnassignSeats)
               .then((returnVal) => {
       
                 // if ((returnVal.status == "401" && returnVal.data == "") || (returnVal.status == "500"))
                 if (returnVal.status == "401" && returnVal.data == "") {
                   document.getElementById("showAndHideSpinner").style.display = "none";
                   //  notify(returnVal.statusText);
                   settriggerModal(true);
                 }
                 else {
                   document.getElementById("showAndHideSpinner").style.display = "none";
                   if (returnVal.data.isError == false) {
                     setUnAssignAll(true);
                     var RecordLocator = SearchedFlightDetails.recordLocator;
                     fncSearchApiCallForSeat(RecordLocator, "RELOAD", "")
                   }
                   else {
                     document.getElementById("showAndHideSpinner").style.display = "none";
              if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                      settriggerModal(true);
              } else {
                     notify(returnVal.data.errorDetail.errorMessage);
                   }
                 }
          }
               })
               .catch(err => console.log("Axios err: ", err))
       
           }
           else {
             //modal popup displaying 
             setshowErrorPopup(true);
           }
       
         }
    
         function fncSetSelectedPassengerData(flightDetailsData, seatMapData, feeWaived) {
        debugger;
       fncNextButtonFocus();
       var SegmentKey = selectedPassengerAndSegment.segmentKey;
       var PassengerKey = selectedPassengerAndSegment.passengerKey;
       var unitkey = "";
       var compartmentDesignator = "";
       var unitDesignator = "";
   
       var PassengerName = "";
       var PassengerGender = "";
       var WithORwithoutINFT = "";
       var SEATDETAIL = "";
       var Amount = "";
       var AisleOrWindow = "";
       var Seatclass = "";
       var PassengerTypeCode = "";  //ADULT OR CHILD
       var PassengerWheelChair = "";
   
   
       var setData = [{}];
       var countSelPass = 0;
   
       let currentSegmentflightReference = '';
       var vSearchedPASSENGER = flightDetailsData.passenger.filter(pax => pax.IsSelected);
       for (var i = 0; i < vSearchedPASSENGER.length; i++) {
         // if (vSearchedPASSENGER[i].IsSelected == true && vSearchedPASSENGER[i].passengerKey == PassengerKey) {
         // if (vSearchedPASSENGER[i].IsSelected == true) {
         PassengerName = vSearchedPASSENGER[i].name.last + ", " + vSearchedPASSENGER[i].name.first + " " + vSearchedPASSENGER[i].name.title;
         PassengerGender = vSearchedPASSENGER[i].name.title == "MS" || vSearchedPASSENGER[i].name.title == "MRS" ||
           vSearchedPASSENGER[i].name.title == "MISS" ? "FEMALE" : "MALE";
         PassengerTypeCode = vSearchedPASSENGER[i].passengerTypeCode;
         WithORwithoutINFT = vSearchedPASSENGER[i].infant == null ? "NO" : "INFT";
   
         setData[countSelPass] = {
           "PassengerName": PassengerName,
           "PassengerGender": PassengerGender,
           "WithORwithoutINFT": WithORwithoutINFT,
           "SEATDETAIL": "",
           "Amount": "",
           "AisleOrWindow": "",
           "SeatClass": "",
           "PassengerInfo": "",
           "PassengerTypeCode": PassengerTypeCode,
           "PassengerKey": vSearchedPASSENGER[i].passengerKey,
           "PassengerWheelChair": "",
           "unitkey": "",
           "SelectedPassenger": vSearchedPASSENGER[i].passengerKey == PassengerKey ? true : false
         }
         countSelPass = countSelPass + 1;
         // }
       }
   
   
       var vSearchedFlightDetails = flightDetailsData.journeys;
       for (var i = 0; i < vSearchedFlightDetails.length; i++) {
         var segments = vSearchedFlightDetails[i].segments;
         for (var j = 0; j < segments.length; j++) {
           if (segments[j].segmentKey == SegmentKey && segments[j].IsSelected == true) {
             currentSegmentflightReference = segments[j].flightReference;
             Seatclass = segments[j].productClass + ":" + segments[j].classOfService
             var passengerSegmentData = segments[j].passengerSegment;
             for (var k = 0; k < passengerSegmentData.length; k++) {
               // if (passengerSegmentData[k].passengerKey == PassengerKey)
               for (var v = 0; v < setData.length; v++) {
                 if (passengerSegmentData[k].passengerKey == setData[v].PassengerKey) {
                   setData[v].SeatClass = Seatclass;
                   if (passengerSegmentData[k].seats.length > 0) {
                     // unitkey = passengerSegmentData[k].seats[0].unitKey;
                     // compartmentDesignator = passengerSegmentData[k].seats[0].compartmentDesignator;
                     // SEATDETAIL = passengerSegmentData[k].seats[0].unitDesignator;
                     setData[v].unitkey = passengerSegmentData[k].seats[0].unitKey;
                     setData[v].SEATDETAIL = passengerSegmentData[k].seats[0].unitDesignator;
   
                   }
                   for (var l = 0; l < passengerSegmentData[k].ssrs.length; l++) {
                     if (passengerSegmentData[k].ssrs[l].ssrCode == "WCHC"
                       || passengerSegmentData[k].ssrs[l].ssrCode == "WCHR"
                       || passengerSegmentData[k].ssrs[l].ssrCode == "WCHS"
                       || passengerSegmentData[k].ssrs[l].ssrCode == "WCHX") {
                       setData[v].PassengerWheelChair = "YES";
                     }
                   }
                 }
               }
             }
           }
         }
       }
   
       // console.log('vSearchedPASSENGER', vSearchedPASSENGER);
       // debugger;
       for (var v = 0; v < setData.length; v++) {
         // debugger;
         for (var i = 0; i < seatMapData.seatMapResponse.seatMap.decks[0].compartments.length; i++) {
           var fileterd = seatMapData.seatMapResponse.seatMap.decks[0].compartments[i].units.filter(record => record.unitKey === setData[v].unitkey)
           if (fileterd.length > 0) {
             var group = fileterd[0].group;
             var FilteredGroupForAmount = seatMapData.seatMapResponse.fees[0].groups.filter(record => record.group === group)
             // Amount = FilteredGroupForAmount[0].fees[0].toatlAmount;
             if (vSearchedPASSENGER[0].fees.filter(fee => fee.flightReference === currentSegmentflightReference).length > 0) {
               setData[v].Amount = FilteredGroupForAmount[0].fees[0].toatlAmount;
             } else {
               setData[v].Amount = 0;
             }
             // if (feeWaived === 'WA') {
             //   setData[v].Amount = 0;
             // } else {
             //   setData[v].Amount = FilteredGroupForAmount[0].fees[0].toatlAmount;
             // }
             for (var j = 0; j < fileterd[0].properties.length; j++) {
               if (fileterd[0].properties[j].code == "WINDOW" && fileterd[0].properties[j].value == "True") {
                 // AisleOrWindow = "WINDOW";
                 setData[v].AisleOrWindow = "WINDOW";
                 break;
               }
               else if (fileterd[0].properties[j].code == "AISLE" && fileterd[0].properties[j].value == "True") {
                 // AisleOrWindow = "AISLE";
                 setData[v].AisleOrWindow = "AISLE";
                 break;
               }
               else {
                 // AisleOrWindow = "MIDDLE";
                 setData[v].AisleOrWindow = "MIDDLE";
               }
             }
   
           }
         }
   
         var PassengerInfo = "";
         if (setData[v].PassengerGender == "MALE" && setData[v].PassengerTypeCode == "ADT" && setData[v].WithORwithoutINFT == "INFT" && setData[v].PassengerWheelChair == "YES") {
           PassengerInfo = "MALEWITHWHEELCHAIRANDINFT"
           setData[v].PassengerInfo = PassengerInfo;
         }
         else if (setData[v].PassengerGender == "MALE" && setData[v].PassengerTypeCode == "ADT" && setData[v].WithORwithoutINFT == "NO" && setData[v].PassengerWheelChair == "YES") {
           PassengerInfo = "MALEWITHWHEELCHAIR"
           setData[v].PassengerInfo = PassengerInfo;
   
         }
         else if (setData[v].PassengerGender == "MALE" && setData[v].PassengerTypeCode == "ADT" && setData[v].WithORwithoutINFT == "NO" && setData[v].PassengerWheelChair == "") {
           PassengerInfo = "MALE"
           setData[v].PassengerInfo = PassengerInfo;
   
         }
         else if (setData[v].PassengerGender == "MALE" && setData[v].PassengerTypeCode == "ADT" && setData[v].WithORwithoutINFT == "INFT" && setData[v].PassengerWheelChair == "") {
           PassengerInfo = "MALEWITHINFANT"
           setData[v].PassengerInfo = PassengerInfo;
   
         }
         else if (setData[v].PassengerGender == "MALE" && setData[v].PassengerTypeCode == "CHD" && setData[v].WithORwithoutINFT == "INFT" && setData[v].PassengerWheelChair == "YES") {
           //------ child male
           PassengerInfo = "MALECHILDWITHWHEELCHAIRANDINFT";
           setData[v].PassengerInfo = PassengerInfo;
         }
         else if (setData[v].PassengerGender == "MALE" && setData[v].PassengerTypeCode == "CHD" && setData[v].WithORwithoutINFT == "NO" && setData[v].PassengerWheelChair == "YES") {
           PassengerInfo = "MALECHILDWITHWHEELCHAIR";
           setData[v].PassengerInfo = PassengerInfo;
         }
         else if (setData[v].PassengerGender == "MALE" && setData[v].PassengerTypeCode == "CHD" && setData[v].WithORwithoutINFT == "NO" && setData[v].PassengerWheelChair == "") {
           PassengerInfo = "MALECHILD";
           setData[v].PassengerInfo = PassengerInfo;
         }
         else if (setData[v].PassengerGender == "MALE" && setData[v].PassengerTypeCode == "CHD" && setData[v].WithORwithoutINFT == "INFT" && setData[v].PassengerWheelChair == "") {
           PassengerInfo = "MALECHILDWITHINFANT";
           setData[v].PassengerInfo = PassengerInfo;
         }
         else if (setData[v].PassengerGender == "FEMALE" && setData[v].PassengerTypeCode == "ADT" && setData[v].WithORwithoutINFT == "INFT" && setData[v].PassengerWheelChair == "YES") {
           //------ FEMALE 
           PassengerInfo = "FEMALEWITHWHEELCHAIRANDINFT";
           setData[v].PassengerInfo = PassengerInfo;
         }
         else if (setData[v].PassengerGender == "FEMALE" && setData[v].PassengerTypeCode == "ADT" && setData[v].WithORwithoutINFT == "NO" && setData[v].PassengerWheelChair == "YES") {
           PassengerInfo = "FEMALEWITHWHEELCHAIR";
           setData[v].PassengerInfo = PassengerInfo;
         }
         else if (setData[v].PassengerGender == "FEMALE" && setData[v].PassengerTypeCode == "ADT" && setData[v].WithORwithoutINFT == "NO" && setData[v].PassengerWheelChair == "") {
           PassengerInfo = "FEMALE";
           setData[v].PassengerInfo = PassengerInfo;
         }
         else if (setData[v].PassengerGender == "FEMALE" && setData[v].PassengerTypeCode == "ADT" && setData[v].WithORwithoutINFT == "INFT" && setData[v].PassengerWheelChair == "") {
           PassengerInfo = "FEMALEWITHINFANT";
           setData[v].PassengerInfo = PassengerInfo;
         }
         else if (setData[v].PassengerGender == "FEMALE" && setData[v].PassengerTypeCode == "CHD" && setData[v].WithORwithoutINFT == "INFT" && setData[v].PassengerWheelChair == "YES") {
           //------ FEMALE CHILD 
           PassengerInfo = "FEMALECHILDWITHWHEELCHAIRANDINFT";
           setData[v].PassengerInfo = PassengerInfo;
         }
         else if (setData[v].PassengerGender == "FEMALE" && setData[v].PassengerTypeCode == "CHD" && setData[v].WithORwithoutINFT == "NO" && setData[v].PassengerWheelChair == "YES") {
           PassengerInfo = "FEMALECHILDWITHWHEELCHAIR";
           setData[v].PassengerInfo = PassengerInfo;
         }
         else if (setData[v].PassengerGender == "FEMALE" && setData[v].PassengerTypeCode == "CHD" && setData[v].WithORwithoutINFT == "NO" && setData[v].PassengerWheelChair == "") {
           PassengerInfo = "FEMALECHILD";
           setData[v].PassengerInfo = PassengerInfo;
         }
         else if (setData[v].PassengerGender == "FEMALE" && setData[v].PassengerTypeCode == "CHD" && setData[v].WithORwithoutINFT == "INFT" && setData[v].PassengerWheelChair == "") {
           PassengerInfo = "FEMALECHILDWITHINFANT";
           setData[v].PassengerInfo = PassengerInfo;
         }
       }
   
       setUserSeatDetails(setData);
       document.getElementById("showAndHideSpinner").style.display = "none";
   
       }

     function fncSearchApiCallForSeat(recordlocator, isReloaded, SeatMap, countOfRows, feeWaived = '') {
      // debugger; 
      fncNextButtonFocus();
      document.getElementById("showAndHideSpinner").style.display = "block";
      if (countOfRows) {
        setcountOfRowsFormed(countOfRows)
      }
      fncGetBookingFromState()
        .then((returnVal) => {
          // debugger
          // if ((returnVal.status == "401" && returnVal.data == "") || (returnVal.status == "500"))
          if (returnVal.status == "401" && returnVal.data == "") {
            document.getElementById("showAndHideSpinner").style.display = "none";
            // notify(returnVal.statusText);
            settriggerModal(true);
          }
          else {
            if (returnVal.data.isError == false) {
  
  
              if (returnVal.data.flightDetails != null) {
  
                var assignStateAgain = fncAssignSearchedCheckboxes(SearchedSelectedPassengerData, returnVal.data.flightDetails, "AUTOSEATASSIGN");
              }
              dispatch(searchCredential(
                {
                  type: "",
                  SearchedRecordData: stSearchedRecordData,
                  SearchedFlightDetails: assignStateAgain
                }
              ));
              if (isReloaded === "RELOAD") {
                fncLoadSeatMapWithDetailsNew(selectedPassengerAndSegment.segmentKey, selectedPassengerAndSegment.recordLocator, assignStateAgain, feeWaived);
              }
              else {
                if (feeWaived === 'WA') {
                  fncSetSelectedPassengerData(assignStateAgain, SeatMap, feeWaived);
                } else {
                  fncSetSelectedPassengerData(assignStateAgain, SeatMap);
                }
              }
  
            }
            else {
              document.getElementById("showAndHideSpinner").style.display = "none";
            if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                    settriggerModal(true);
            } else {
              notify(returnVal.data.errorDetail.errorMessage);
            }
          }
          document.getElementById("showAndHideSpinner").style.display = "none";
          }
  
        })
        .catch(err => console.log("Axios err: ", err))
     }
  
     function selectJumpSeat(e) {
      let checked = e.currentTarget.checked;
      if (checked) {
        setJumpSeat(true);
        dispatch(jumpSeatCredential(
          {
            type: "SELECT_JUMP_SEAT",
            isJumpSeatSelected: true
          }
        ));
      } else {
        setJumpSeat(false);
        dispatch(jumpSeatCredential(
          {
            type: "SELECT_JUMP_SEAT",
            isJumpSeatSelected: false
          }
        ));
      }
    }

    function fncAutoAssignSeats() {
  
      //     fncNextButtonFocus();
      // var departureStatus = fncCheckDepartedFlight(SearchedFlightDetails,segmentKey);
      var departureStatus = fncCheckDepartedFlight(SearchedFlightDetails, "");
      var count = 0;
      for (var i = 0; i < departureStatus.length; i++) {
        if (departureStatus[i]) {
          count = count + 1;
        }
      }
      if (count === departureStatus.length) {
        // open popup and not call api all are departed
        setShow(false);
        setshowErrorPopup(true);
      }
      else if (count === 0) {
        // yet to be departed
        var segmentKey = "";
        var vSearchedFlightDetails = SearchedFlightDetails;
        var IsAutoAssign = true;
        var primaryPassengerKey = "";
        for (var i = 0; i < vSearchedFlightDetails.passenger.length; i++) {
          if (vSearchedFlightDetails.passenger[i].IsSelected == true) {
            primaryPassengerKey = vSearchedFlightDetails.passenger[i].passengerKey;
            break;
          }
        }
        var JourneyKey = "";
        let next = 0;
        for (var i = 0; i < vSearchedFlightDetails.journeys.length; i++) {
          var segments = vSearchedFlightDetails.journeys[i].segments;
          for (var j = 0; j < segments.length; j++) {
            if (segments[j].IsSelected == true) {
              segmentKey = segments[j].segmentKey;
              JourneyKey = vSearchedFlightDetails.journeys[i].journeyKey;
              next = 1;
              break;
            }
          }
          if (next === 1) {
            break;
          }
        }
        var waiveFee = false;
        var RecordLocator = vSearchedFlightDetails.recordLocator;
        var currencyCode = vSearchedFlightDetails.currencyCode;
        var seatedNearPrimary = [];
        for (var i = 0; i < vSearchedFlightDetails.passenger.length; i++) {
          if (vSearchedFlightDetails.passenger[i].IsSelected == true) {
            seatedNearPrimary.push({
              "passengerKey": vSearchedFlightDetails.passenger[i].passengerKey
            })
          }
        }
  
        selectedPassengerAndSegment.segmentKey = segmentKey;
        selectedPassengerAndSegment.passengerKey = primaryPassengerKey;
        selectedPassengerAndSegment.journeyKey = JourneyKey
        selectedPassengerAndSegment.recordLocator = RecordLocator
        selectedPassengerAndSegment.currencyCode = currencyCode
        selectedPassengerAndSegment.unitDesignator = "";
  
  
  
        setSelectedPassengerSeatData({
          "passengerKey": primaryPassengerKey,
          "journeyKey": JourneyKey,
          "recordLocator": RecordLocator,
          "currencyCode": currencyCode,
          "unitDesignator": "",
          "segmentKey": segmentKey
        });
        const AutoAssignSeatRequest = [];
        AutoAssignSeatRequest.push({
          "primaryPassengerKey": primaryPassengerKey,
          "SegmentKey": "",
          "JourneyKey": JourneyKey,
          "waiveFee": waiveFee,
          "RecordLocator": RecordLocator,
          "seatedNearPrimary": seatedNearPrimary
        })
  
        fncAutoAssignPassengerSeats(IsAutoAssign, AutoAssignSeatRequest, 'CheckedIn')
          .then((returnVal) => {
            // debugger;
            if (returnVal.status == "401" && returnVal.data == "") {
              document.getElementById("showAndHideSpinner").style.display = "none";
              settriggerModal(true);
            }
            else {
              document.getElementById("showAndHideSpinner").style.display = "none";
              if (returnVal.data.isError == false) {
                setUnAssignAll(false);
                // fncSearchApiCallForSeat(RecordLocator,"");       
                setShow(false);
                fncLoadSeatMapWithDetailsNew(segmentKey, RecordLocator, "");
              if (jumpSeat) {
                setJumpSeat(false)
                dispatch(jumpSeatCredential(
                  {
                    type: "SELECT_JUMP_SEAT",
                    isJumpSeatSelected: false
                  }
                ));
              }
              
              }
              else {
                setShow(false);
                document.getElementById("showAndHideSpinner").style.display = "none";
              if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                      settriggerModal(true);
              } else {
                notify(returnVal.data.errorDetail.errorMessage);
              }
              }
            }
  
          })
          .catch(err => console.log("Axios err: ", err))
      }
      else if (count < departureStatus.length) {
  
        // const getSegmentIndex = departureStatus.findIndex(ds => ds);
        // means one is departed one is pending
        setshowErrorPopup(true);
        var segmentKey = "";
        var vSearchedFlightDetails = SearchedFlightDetails;
        var IsAutoAssign = true;
        var primaryPassengerKey = "";
        for (var i = 0; i < vSearchedFlightDetails.passenger.length; i++) {
          if (vSearchedFlightDetails.passenger[i].IsSelected == true) {
            primaryPassengerKey = vSearchedFlightDetails.passenger[i].passengerKey;
            break;
          }
        }
        var JourneyKey = "";
        let next = 0;
        // let autoAssignSegment;
        for (var i = 0; i < vSearchedFlightDetails.journeys.length; i++) {
          var segments = vSearchedFlightDetails.journeys[i].segments;
          for (var j = 0; j < segments.length; j++) {
            if (segments[j].IsSelected == true) {
              // if (getSegmentIndex !== -1 && j === getSegmentIndex) {
              //   autoAssignSegment = segments[j].segmentKey;
              // }
              segmentKey = segments[j].segmentKey;
              JourneyKey = vSearchedFlightDetails.journeys[i].journeyKey;
              next = 1;
              break;
            }
          }
          if (next == 1) {
            break;
          }
        }
        var waiveFee = true;
        var RecordLocator = vSearchedFlightDetails.recordLocator;
        var currencyCode = vSearchedFlightDetails.currencyCode;
        var seatedNearPrimary = [];
        for (var i = 0; i < vSearchedFlightDetails.passenger.length; i++) {
          if (vSearchedFlightDetails.passenger[i].IsSelected == true) {
            seatedNearPrimary.push({
              "passengerKey": vSearchedFlightDetails.passenger[i].passengerKey
            })
          }
        }
  
        selectedPassengerAndSegment.segmentKey = segmentKey;
        selectedPassengerAndSegment.passengerKey = primaryPassengerKey;
        selectedPassengerAndSegment.journeyKey = JourneyKey
        selectedPassengerAndSegment.recordLocator = RecordLocator
        selectedPassengerAndSegment.currencyCode = currencyCode
        selectedPassengerAndSegment.unitDesignator = "";
  
        setSelectedPassengerSeatData({
          "passengerKey": primaryPassengerKey,
          "journeyKey": JourneyKey,
          "recordLocator": RecordLocator,
          "currencyCode": currencyCode,
          "unitDesignator": "",
          "segmentKey": segmentKey
        });
        fncLoadSeatMapWithDetailsNew(segmentKey, RecordLocator, "");
        // fncAutoAssignPassengerSeats(IsAutoAssign, primaryPassengerKey, JourneyKey, waiveFee, RecordLocator, seatedNearPrimary, autoAssignSegment)
        //   .then((returnVal) => {
  
        //     // if ((returnVal.status == "401" && returnVal.data == "") || (returnVal.status == "500"))
        //     if (returnVal.status == "401" && returnVal.data == "") {
        //       document.getElementById("showAndHideSpinner").style.display = "none";
        //       // notify(returnVal.statusText);
        //       settriggerModal(true);
        //     }
        //     else {
        //       document.getElementById("showAndHideSpinner").style.display = "none";
        //       if (returnVal.data.isError == false) {
        //         setUnAssignAll(false);
        //         // fncSearchApiCallForSeat(RecordLocator,"");
  
        //         setShow(false);
  
        //         fncLoadSeatMapWithDetailsNew(segmentKey, RecordLocator,"");
        //       }
        //       else {
        //         // setShow(false);
        //         document.getElementById("showAndHideSpinner").style.display = "none";
        //         notify(returnVal.data.errorDetail.errorMessage);
        //       }
        //     }
  
        //   })
        //   .catch(err => console.log("Axios err: ", err))
      }
    }
       
         //--------------------- new seat map function -----------------------
         function fncLoadSeatMapWithDetailsNew(segmentKey, RecordLocator, SearchedData, feeWaived = '') {

          // debugger;
          fncNextButtonFocus();
          var vSearchedFlightDetails = SearchedData == "" ? SearchedFlightDetails : SearchedData;
          document.getElementById("showAndHideSpinner").style.display = "block";
      
          fncCallSeatMapApi(segmentKey, checkinModule)
            .then((returnVal) => {
      
              // debugger;
              document.getElementById("showAndHideSpinner").style.display = "block";
              // if ((returnVal.status == "401" && returnVal.data == "") || (returnVal.status == "500"))
              if (returnVal.status == "401" && returnVal.data == "") {
                document.getElementById("showAndHideSpinner").style.display = "none";
                // notify(returnVal.statusText);
                settriggerModal(true);
              }
              else {
                if (returnVal.data.isError == false) {
      
                  var seats = returnVal.data.seatMapResponse.seatMap.decks[0].compartments;
                  // setSeatMapApiData(returnVal.data);
      
                  var compartmentsLength = returnVal.data.seatMapResponse.seatMap.decks[0].compartments.length;
                  let countOfRowsFormedAftrAddingFalseSets = [];
                  // For multiple compartments
                  if (compartmentsLength > 1) {
                    const result = [];
                    const map = new Map();
                    for (const item of seats.Compartments[1].Seats) {
                      if (item.SeatDesignator.length == 2) {
                        var test = item.SeatDesignator.substring(item.SeatDesignator.length - 1, 2);
                        if (!map.has(item.SeatDesignator.substring(item.SeatDesignator.length - 1, 2))) {
                          map.set(item.SeatDesignator.substring(item.SeatDesignator.length - 1, 2), true);    // set any value to Map
                          result.push({
                            SeatDesignator: item.SeatDesignator.substring(item.SeatDesignator.length - 1, 2),
                            X: item.X
                          });
                        }
                      }
                      else {
                        var test = item.SeatDesignator.substring(item.SeatDesignator.length - 1, 3);
                        if (!map.has(item.SeatDesignator.substring(item.SeatDesignator.length - 1, 3))) {
                          map.set(item.SeatDesignator.substring(item.SeatDesignator.length - 1, 3), true);    // set any value to Map
                          result.push({
                            SeatDesignator: item.SeatDesignator.substring(item.SeatDesignator.length - 1, 3),
                            X: item.X
                          });
                        }
                      }
      
                    }
                    var arrayWithMargin = [];
                    var mar = 0;
                    var marginAllowed = 0;
                    for (var i = 0; i < result.length; i++) {
                      if (i == 0) {
                        if (result[i].SeatDesignator != "") {
                          arrayWithMargin[i] = {
                            SeatDesignator: result[i].SeatDesignator,
                            X: result[i].X,
                            Margin: 0,
                          }
                        }
      
                      }
                      else {
                        if (i == 1) {
                          mar = result[i].X - result[i - 1].X;
                        }
                        var diff = result[i].X - result[i - 1].X;
                        if (diff > mar) {
                          marginAllowed = 1;
                        }
                        else {
                          marginAllowed = 0;
                        }
                        if (result[i].SeatDesignator != "") {
                          arrayWithMargin[i] = {
                            SeatDesignator: result[i].SeatDesignator,
                            X: result[i].X,
                            Margin: marginAllowed,
                          }
                        }
      
      
                      }
                    }
      
      
                    var marSeats = 0;
                    var marginAllowedSeats = 0;
                    var countOfRowsFormed = [];
      
                    var counter = 0;
                    for (var k = 0; k < seats.Compartments.length; k++) {
                      var compartmentSeats = seats.Compartments[k].Seats;
                      const maxValueOfY = Math.max(...compartmentSeats.map(o => o.SeatRow), 0);
                      const minValueOfY = Math.min(...compartmentSeats.map(o => o.SeatRow), 0);
      
      
                      for (var j = 0; j < maxValueOfY; j++) {
                        var arrayWithMarginSeats = [];
                        var count = 0;
      
      
                        for (var i = 0; i < compartmentSeats.length; i++) {
                          if ((j + 1) === compartmentSeats[i].SeatRow) {
      
                            if (i === 0) {
      
                              // var obj = arrayWithMargin.find(o => o.SeatDesignator === compartmentSeats[i].SeatDesignator.substring(compartmentSeats[i].SeatDesignator.length-1,2));
      
                              arrayWithMarginSeats[count] = {
                                SeatDesignator: compartmentSeats[i].SeatDesignator,
                                X: compartmentSeats[i].X,
                                Margin: 0,
                                SeatRow: compartmentSeats[i].SeatRow,
                                Status: compartmentSeats[i].Status
                              }
                            }
                            else {
                              if (i === 1) {
                                marSeats = compartmentSeats[i].X - compartmentSeats[i - 1].X;
                              }
                              var diff = compartmentSeats[i].X - compartmentSeats[i - 1].X;
                              if (diff > marSeats) {
                                marginAllowedSeats = 1;
                              }
                              else {
                                marginAllowedSeats = 0;
                              }
      
                              // var obj = arrayWithMargin.find(o => o.SeatDesignator === compartmentSeats[i].SeatDesignator.substring(compartmentSeats[i].SeatDesignator.length-1,2));
      
                              arrayWithMarginSeats[count] = {
                                SeatDesignator: compartmentSeats[i].SeatDesignator,
                                X: compartmentSeats[i].X,
                                Margin: marginAllowedSeats,
                                SeatRow: compartmentSeats[i].SeatRow,
                                Status: compartmentSeats[i].Status
                              }
                            }
                            count = count + 1;
                          }
                        }
                        if (arrayWithMarginSeats.length != 0) {
                          countOfRowsFormed[counter] = {
                            id: counter,
                            dataToBind: arrayWithMarginSeats
                          };
                          counter = counter + 1;
                        }
                      }
                    }
      
                    // arrayWithMargin
      
      
                    //------------------------------------------------------------------ new Implementations-------------------------------------
      
      
                    for (var i = 0; i < countOfRowsFormed.length; i++) {
                      var arrayWithMarginAftrAddingFalseSets = [];
                      var fcount = 0;
                      var seatCount = "";
                      for (var j = 0; j < arrayWithMargin.length; j++) {
                        var obj = countOfRowsFormed[i].dataToBind.find(o => o.SeatDesignator.replace(/[0-9]/g, '') === arrayWithMargin[j].SeatDesignator);
      
                        if (obj != undefined) {
                          seatCount = obj.SeatRow;
                          arrayWithMarginAftrAddingFalseSets[fcount] = {
                            SeatDesignator: obj.SeatDesignator,
                            X: obj.X,
                            Margin: obj.Margin,
                            SeatRow: obj.SeatRow,
                            Status: obj.Status
                          }
                        }
                        else {
                          arrayWithMarginAftrAddingFalseSets[fcount] = {
                            SeatDesignator: "false",
                            X: 0,
                            Margin: 0,
                            SeatRow: '',
                            Status: 0
                          }
                        }
                        fcount = fcount + 1;
                      }
                      countOfRowsFormedAftrAddingFalseSets[i] = {
                        id: seatCount,
                        dataToBind: arrayWithMarginAftrAddingFalseSets
                      };
      
                    }
      
                    this.setState({
                      // st_countOfRowsFormed: countOfRowsFormedAftrAddingFalseSets,
                      st_AirlineHeader: arrayWithMargin
                    })
                  }
                  else {
                    // For single compartment
                    //   const maxValueOfY = Math.max(...returnVal.data.compartments[0].units.map(o => o.designator), 0); 
                    //   const maxValueOfY = Math.max(...seats.Compartments[0].Seats.map(o => o.SeatRow), 0);   
      
      
                    const maxValueOfY = 20;
                    const result = [];
                    const uniqueROWS = [];
                    const map = new Map();
                    // changes on 27 August 2020
                    for (const item of returnVal.data.seatMapResponse.seatMap.decks[0].compartments[0].units) {
                      if (item.unitKey != null) {
                        if (item.designator.length == 2) {
                          var test = item.designator.substring(item.designator.length - 1, 2);
                          if (!map.has(item.designator.substring(item.designator.length - 1, 2))) {
                            map.set(item.designator.substring(item.designator.length - 1, 2), true);    // set any value to Map
                            result.push({
                              SeatDesignator: item.designator.substring(item.designator.length - 1, 2),
                              X: item.x
                            });
                          }
                        }
                        else {
                          var test = item.designator.substring(item.designator.length - 1, 3);
                          if (!map.has(item.designator.substring(item.designator.length - 1, 3))) {
                            map.set(item.designator.substring(item.designator.length - 1, 3), true);    // set any value to Map
                            result.push({
                              SeatDesignator: item.designator.substring(item.designator.length - 1, 3),
                              X: item.x
                            });
                          }
                        }
                      }
                    }
      
                    result.sort((a, b) => a.SeatDesignator > b.SeatDesignator ? 1 : -1);
      
                    for (const item of returnVal.data.seatMapResponse.seatMap.decks[0].compartments[0].units) {
                      if (item.unitKey != null) {
      
                        var test = item.designator.replace(/[^0-9]/g, '');
      
                        if (!map.has(parseInt(test))) {
                          map.set(parseInt(test), true);    // set any value to Map
                          uniqueROWS.push(parseInt(test));
                        }
      
                      }
                    }
      
      
      
                    var arrayWithMargin = [];
                    var mar = 0;
                    var marginAllowed = 0;
                    // console.log('result--------', result)
                    // debugger
                    if (result.length === 3) {
                      const buildNewArray = (arr) => {
                        let newArray = arr.map((item, index) => {
                            let Margin = 0;
                    
                            if (index > 0 && index < arr.length - 1) {
                                let prevDiff = arr[index].X - arr[index - 1].X;
                                let nextDiff = arr[index + 1].X - arr[index].X;
                    
                                if (prevDiff !== nextDiff) {
                                  Margin = 1;
                                }
                            }
                    
                            return { ...item, Margin };
                        });
                    
                        return newArray;
                    };
                    arrayWithMargin = buildNewArray(result)
      
                    } else {
                      for (var i = 0; i < result.length; i++)  // changed on 27 august 2020
                      {
                        if (i == 0) {
                          if (result[i].SeatDesignator != "") {
                            arrayWithMargin[i] = {
                              SeatDesignator: result[i].SeatDesignator,
                              X: result[i].X,
                              Margin: 0,
                            }
                          }
      
                        }
                        else {
                          if (i == 1) {
                            mar = result[i].X - result[i - 1].X;
                          }
                          var diff = result[i].X - result[i - 1].X;
                          if (diff > mar) {
                            marginAllowed = 1;
                          }
                          else {
                            marginAllowed = 0;
                          }
                          if (result[i].SeatDesignator != "") {
                            arrayWithMargin[i] = {
                              SeatDesignator: result[i].SeatDesignator,
                              X: result[i].X,
                              Margin: marginAllowed,
                            }
                          }
                        }
                      }
                    }
                    setAirlineHeader(arrayWithMargin);
                    // setSegmentKeyForCurrentSeatmap(segmentKey);
                    // debugger;
      
                    var marSeats = 0;
                    var marSeatsY = 0;
                    var marginAllowedSeats = 0;
                    var marginAllowedSeatsY = 0;
                    var seats = returnVal.data.seatMapResponse.seatMap.decks[0].compartments[0].units;
                    var countOfRowsFormed = [];
                    for (var j = 0; j < uniqueROWS.length; j++) {
                      var arrayWithMarginSeats = [];
                      var count = 0;
                      var isEntered = false;
                      var comparewithlast = 0;
                      for (var i = 0; i < seats.length; i++) {
                        if (seats[i].unitKey != null) {
                          if (uniqueROWS[j] == parseInt(seats[i].designator.replace(/[^0-9]/g, ''))) {
                            if (isEntered == false) {
                              comparewithlast = i;
                              isEntered = true;
                            }
      
                            if (i == 0) {
                              arrayWithMarginSeats[count] = {
                                SeatDesignator: seats[i].designator,
                                X: seats[i].x,
                                Margin: 0,
                                SeatRow: seats[i].assignable,
                                Status: seats[i].availability,
                                Y: fncSeatGroupSelection(seats[i].group),
                                UnitKey: seats[i].unitKey
                              }
                            }
                            else {
                              if (i == 1) {
                                marSeats = seats[i].x - seats[i - 1].x;
                                // marSeatsY = seats[i].y - seats[i-1].y;
                              }
                              var diff = seats[i].x - seats[i - 1].x;
                              var diffY = seats[i].y - seats[comparewithlast == 0 ? 0 : comparewithlast - 1].y;
                              if (diff > marSeats) {
                                marginAllowedSeats = 1;
                              }
                              else {
                                marginAllowedSeats = 0;
                              }
      
                              if (diffY > 2) {
                                marginAllowedSeatsY = 1;
                              }
                              else {
                                marginAllowedSeatsY = 0;
                              }
                              arrayWithMarginSeats[count] = {
                                SeatDesignator: seats[i].designator,
                                X: seats[i].x,
                                Margin: marginAllowedSeats,
                                SeatRow: seats[i].assignable,
                                Status: seats[i].availability,
                                // Y: marginAllowedSeatsY,
                                Y: fncSeatGroupSelection(seats[i].group),
                                UnitKey: seats[i].unitKey
                              }
                            }
                            count = count + 1;
                          }
                        }
                      }
                      countOfRowsFormed[j] = {
                        id: uniqueROWS[j],
                        dataToBind: arrayWithMarginSeats
                      };
                    }
                    //------------------------------------------------------------------ new Implementations-------------------------------------
                    // var countOfRowsFormedAftrAddingFalseSets = [];
      
                    for (var i = 0; i < countOfRowsFormed.length; i++) {
                      var arrayWithMarginAftrAddingFalseSets = [];
                      var fcount = 0;
                      var seatCount = "";
                      for (var j = 0; j < arrayWithMargin.length; j++) {
                        var obj = countOfRowsFormed[i].dataToBind.find(o => o.SeatDesignator.replace(/[0-9]/g, '') === arrayWithMargin[j].SeatDesignator);
                        if (obj != undefined) {
                          seatCount = countOfRowsFormed[i].id;
                          arrayWithMarginAftrAddingFalseSets[fcount] = {
                            SeatDesignator: obj.SeatDesignator,
                            X: obj.X,
                            Margin: obj.Margin,
                            SeatRow: obj.SeatRow,
                            Status: obj.Status,
                            Y: obj.Y,
                            UnitKey: obj.UnitKey,
                            PNRPassenger: false,
                            PNRPassengerGender: ""
                          }
                        }
                        else {
                          arrayWithMarginAftrAddingFalseSets[fcount] = {
                            SeatDesignator: "false",
                            X: 0,
                            Margin: 0,
                            SeatRow: '',
                            Status: 0,
                            Y: 0,
                            UnitKey: 0,
                            PNRPassenger: false,
                            PNRPassengerGender: ""
                          }
                        }
                        fcount = fcount + 1;
                      }
      
                      // debugger;
                      for (var f = 0; f < arrayWithMarginAftrAddingFalseSets.length; f++) {
                        for (var c = 0; c < vSearchedFlightDetails.journeys.length; c++) {
                          for (var d = 0; d < vSearchedFlightDetails.journeys[c].segments.length; d++) {
                            if (vSearchedFlightDetails.journeys[c].segments[d].IsSelected == true && vSearchedFlightDetails.journeys[c].segments[d].segmentKey == segmentKey) {
                              for (var e = 0; e < vSearchedFlightDetails.journeys[c].segments[d].passengerSegment.length; e++) {
                                if (vSearchedFlightDetails.journeys[c].segments[d].passengerSegment[e].seats.length !== 0) //vSearchedFlightDetails.journeys[c].segments[d].passengerSegment[e].IsSelected==true && 
                                {
                                  if (arrayWithMarginAftrAddingFalseSets[f].SeatDesignator == vSearchedFlightDetails.journeys[c].segments[d].passengerSegment[e].seats[0].unitDesignator) {
                                    var GenderType = fncPassengerInformation(vSearchedFlightDetails.journeys[c].segments[d].passengerSegment[e].passengerKey, SearchedFlightDetails)
                                    arrayWithMarginAftrAddingFalseSets[f].PNRPassenger = true;
                                    arrayWithMarginAftrAddingFalseSets[f].PNRPassengerGender = GenderType;
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
      
      
                      countOfRowsFormedAftrAddingFalseSets[i] = {
                        id: countOfRowsFormed[i].id,
                        dataToBind: arrayWithMarginAftrAddingFalseSets
                      };
      
                    };
      
                    // console.log('countOfRowsFormedAftrAddingFalseSets', countOfRowsFormedAftrAddingFalseSets)
                    function updateSeatMargins(seatArr, headerArr) {
                      // Create a map from headerArr for quick lookup
                      const headerMap = new Map(headerArr.map(item => [item.SeatDesignator, item.Margin]));
                      
                      // Iterate over seatArr and update the Margin
                      seatArr.forEach(row => {
                          row.dataToBind.forEach(seat => {
                              // Extract the last character (seat column) from SeatDesignator
                              const seatType = seat.SeatDesignator.slice(-1);
                              
                              // Update margin if found in headerMap
                              if (headerMap.has(seatType)) {
                                  seat.Margin = headerMap.get(seatType);
                              }
                          });
                      });
                      
                      return seatArr;
                  }
      
                  if (arrayWithMargin.length === 3) {
                    countOfRowsFormedAftrAddingFalseSets = updateSeatMargins(countOfRowsFormedAftrAddingFalseSets, arrayWithMargin);
                  }
                    /// ------------------------------------- NEW IMPLEMENTATION ENDS HERE --------------------------------
      
      
                  }
                  fncSearchApiCallForSeat(RecordLocator, "", returnVal.data, countOfRowsFormedAftrAddingFalseSets, feeWaived);
                  // document.getElementById("showAndHideSpinner").style.display = "none";               
                  // fncSearchApiCallForSeat(RecordLocator, "", returnVal.data);
      
                }
                else {
                  document.getElementById("showAndHideSpinner").style.display = "none";
                  if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                          settriggerModal(true);
                  } else {
                          notify(returnVal.data.errorDetail.errorMessage);
                  }
                }
              }
            })
            .catch(err => console.log("Axios err: ", err))
        }
       
         function fncWaiveDropdownChange(e) {
       
          //  fncNextButtonFocus();
           var SelectedService = e.target.options[e.target.selectedIndex].id;
           setShowWaveTextBox(false);
           if (SelectedService != "") {
             if (SelectedService == "OTH") {
               setShowWaveTextBox(true);
             }
             else {
               setwaveOK(false);
             }
           }
           else {
             setwaveOK(true);
           }
         }
       
         function fncWaveReason(e) {
           setwaveOK(false);
           setWaveReasonTextBox(e.target.value);
         }
       
         function openWaiveFeeModal(paxKey) {
           setFocusedDiv("");
           setPaxKeyForWaiveFee(paxKey);
           setShowWaiveFeeModal(true);
           setpopup(true);
         }
       
         function fncOverrideAmount(WaveOrOverride) {
    debugger
    fncNextButtonFocus();
           const data = []
           // console.log('journeyKey', st_SelectedSeatByPassenger.journeyKey, st_SelectedSeatByPassenger.segmentKey);
           const { journeyKey, segmentKey } = st_SelectedSeatByPassenger;
           const currentJourney = SearchedFlightDetails.journeys.filter(j => j.journeyKey === journeyKey);
           const currentSegmentIdentifier = currentJourney.length && currentJourney[0].segments.filter(s => s.segmentKey === segmentKey)[0].flightReference;
           const passenger = SearchedFlightDetails.passenger.filter(pax => pax.passengerKey === paxKeyForWaiveFee);
           if (passenger.length) {
             const feeKey = passenger[0].fees.filter(fee => fee.code === 'SFBO' && fee.flightReference === currentSegmentIdentifier);
             if (feeKey.length) {
               if (WaveOrOverride === "WA") {
                 data.push({
                   "feeKey": feeKey[0].passengerFeeKey,
                   "amount": 0,
                   "collectedCurrencyCode": "INR"
                 });
                 fncOverrideFee(data)
                   .then((returnVal) => {
                     setShowWaiveFeeModal(false);
                     if (WaveOrOverride === "WA") {
                       // fncCreateComments(returnVal, st_feesOrSSR);
                       fncSearchApiCallForSeat(SearchedFlightDetails.recordLocator, "RELOAD", "", "", "WA");
                       notifySuccess("Fee Wavied Successfully.");
                     }
                   })
                   .catch(err => console.log("Axios err: ", err))
               }
             }
           }
           setFocusedDiv("left");
         }
       
         //-----------------------old seat map ----------------------------
         function fncLoadSeatMapWithDetails(segmentKey, passengerKey, journeyKey, recordLocator, currencyCode, unitDesignator) {
           // debugger;
//     fncNextButtonFocus();
       
           selectedPassengerAndSegment.segmentKey = segmentKey;
           selectedPassengerAndSegment.passengerKey = passengerKey;
           selectedPassengerAndSegment.journeyKey = journeyKey
           selectedPassengerAndSegment.recordLocator = recordLocator
           selectedPassengerAndSegment.currencyCode = currencyCode
           selectedPassengerAndSegment.unitDesignator = unitDesignator;
       
       
       
           const newTodos = { ...st_SelectedSeatByPassenger };
           newTodos.passengerKey = passengerKey;
           newTodos.journeyKey = journeyKey;
           newTodos.recordLocator = recordLocator;
           newTodos.currencyCode = currencyCode;
           newTodos.unitDesignator = unitDesignator;
           newTodos.segmentKey = segmentKey;
           setSelectedPassengerSeatData(newTodos);
       
       
           fncSearchApiCallForSeat(recordLocator, "RELOAD", "");
       
         }
       
         function fncCheckPassengerCheckedInStatus(seat) {
           // debugger;
           var status = false;
           var userDetails = st_UserSeatDetails;
           for (var i = 0; i < userDetails.length; i++) {
             if (userDetails[i].SEATDETAIL == seat) {
               status = true
             }
           }
           return status;
         }
       
       
  // function fncOnSeatchange(e, selectedpassenger) {
  //   const {value} = e.target;
  //   var alphaNumeric = /^[0-9a-zA-Z]+$/;
  //          setSeatFromUserInput(value); 
  //          setUserSeatDetails((prevDetails) =>
  //           prevDetails.map((passenger) =>
  //             passenger.PassengerKey === selectedpassenger.PassengerKey
  //          ? { ...passenger, SEATDETAIL: value } // Update SEATDETAIL for this passenger
  //          : passenger // Keep others unchanged
  //         )
  //       );
  // }

  function fncOnSeatchange(e, selectedpassenger) {
    const { value } = e.target;
  
    setSeatFromUserInput(value);
  
    setUserSeatDetails((prevDetails) =>
      prevDetails.map((passenger) =>
        passenger.PassengerKey === selectedpassenger.PassengerKey
          ? { ...passenger, SEATDETAIL: value }
          : passenger
      )
    );
  
    // Only continue with logic when input is in valid seat format: "12A", "25C", etc.
    const validSeatPattern = /^\d+[A-Za-z]$/;
    if (validSeatPattern.test(value)) {
      const userInputSeat = value.toUpperCase();
      const seatRow = userInputSeat.substring(0, userInputSeat.length - 1);
  
      const seatRowData = st_countOfRowsFormed.find(
        (r) => r.id == seatRow
      );
  
      if (!seatRowData) {
        console.error(`No matching row found for id: ${seatRow}`);
        return;
      }
  
      const SeatData = seatRowData.dataToBind.find(
        (r) => r.SeatDesignator === userInputSeat
      );
  
      fncSeatSelection(SeatData, "SEATMAP", seatRowData.id);
    }
  }
  
  
         
      
         function getSeatForPassenger(seatDetail) {
           setSeatFromUserInput(seatDetail);
         }
       
         function classForHeldForThisSession(SeatData, data) {
           return SeatData.Y == 1 && data.PassengerInfo == "MALEWITHWHEELCHAIRANDINFT" ?
             "maxseat maleWheelChairWithInfant"
             :
             SeatData.Y == 1 && data.PassengerInfo == "MALEWITHWHEELCHAIR" ?
               "maxseat maleWheelChair"
               :
               SeatData.Y == 1 && data.PassengerInfo == "MALE" ?
                 "maxseat male"
                 :
                 SeatData.Y == 1 && data.PassengerInfo == "MALEWITHINFANT" ?
                   "maxseat maleWithChild" // need to change the image class
                   :
                   SeatData.Y == 1 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIRANDINFT" ?
                     "maxseat maleWheelChairWithInfant"
                     :
                     SeatData.Y == 1 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIR" ?
                       "maxseat maleChildWheelChair"
                       :
                       SeatData.Y == 1 && data.PassengerInfo == "MALECHILD" ?
                         "maxseat maleChild"
                         :
                         SeatData.Y == 1 && data.PassengerInfo == "MALECHILDWITHINFANT" ?
                           "maxseat maleWithChild" // need to change the image class
                           :
                           SeatData.Y == 1 && data.PassengerInfo == "FEMALEWITHWHEELCHAIRANDINFT" ?
                             "maxseat femaleWheelChairWithInfant"
                             :
                             SeatData.Y == 1 && data.PassengerInfo == "FEMALEWITHWHEELCHAIR" ?
                               "maxseat femaleWheelChair"
                               :
                               SeatData.Y == 1 && data.PassengerInfo == "FEMALE" ?
                                 "maxseat female"
                                 :
                                 SeatData.Y == 1 && data.PassengerInfo == "FEMALEWITHINFANT" ?
                                   "maxseat femaleWithInfant"
                                   :
                                   SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIRANDINFT" ?
                                     "maxseat femaleWheelChairWithInfant"
                                     :
                                     SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIR" ?
                                       "maxseat femaleChildWheelChair"
                                       :
                                       SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILD" ?
                                         "maxseat femaleChild"
                                         :
                                         SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILDWITHINFANT" ?
                                           "maxseat femaleWithInfant"
                                           :
                                           SeatData.Y == 0 && data.PassengerInfo == "MALEWITHWHEELCHAIRANDINFT" ?
                                             "maleWheelChairWithInfant"
                                             :
                                             SeatData.Y == 0 && data.PassengerInfo == "MALEWITHWHEELCHAIR" ?
                                               "maleWheelChair"
                                               :
                                               SeatData.Y == 0 && data.PassengerInfo == "MALE" ?
                                                 "male"
                                                 :
                                                 SeatData.Y == 0 && data.PassengerInfo == "MALEWITHINFANT" ?
                                                   "maleWithChild" // need to change the image class
                                                   :
                                                   SeatData.Y == 0 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIRANDINFT" ?
                                                     "maleWheelChairWithInfant"
                                                     :
                                                     SeatData.Y == 0 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIR" ?
                                                       "maleChildWheelChair"
                                                       :
                                                       SeatData.Y == 0 && data.PassengerInfo == "MALECHILD" ?
                                                         "maleChild"
                                                         :
                                                         SeatData.Y == 0 && data.PassengerInfo == "MALECHILDWITHINFANT" ?
                                                           "maleWithChild" // need to change the image class
                                                           :
                                                           SeatData.Y == 0 && data.PassengerInfo == "FEMALEWITHWHEELCHAIRANDINFT" ?
                                                             "femaleWheelChairWithInfant"
                                                             :
                                                             SeatData.Y == 0 && data.PassengerInfo == "FEMALEWITHWHEELCHAIR" ?
                                                               "femaleWheelChair"
                                                               :
                                                               SeatData.Y == 0 && data.PassengerInfo == "FEMALE" ?
                                                                 "female"
                                                                 :
                                                                 SeatData.Y == 0 && data.PassengerInfo == "FEMALEWITHINFANT" ?
                                                                   "femaleWithInfant"
                                                                   :
                                                                   SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIRANDINFT" ?
                                                                     "femaleWheelChairWithInfant"
                                                                     :
                                                                     SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIR" ?
                                                                       "femaleChildWheelChair"
                                                                       :
                                                                       SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILD" ?
                                                                         "femaleChild"
                                                                         :
                                                                         SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILDWITHINFANT" ?
                                                                           "femaleWithInfant"
                                                                           : ""
         }
       
         function classForCheckedIn(SeatData) {
       
           let cls = fncCheckPassengerCheckedInStatus(SeatData.SeatDesignator) ? st_UserSeatDetails.length == 0 ? "" : st_UserSeatDetails.map((data) =>
             // data.SelectedPassenger ? "selected" : 
             SeatData.Y == 1 && data.PassengerInfo == "MALEWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
               "maxseat maleWheelChairWithInfant selected"
               :
               SeatData.Y == 1 && data.PassengerInfo == "MALEWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                 "maxseat maleWheelChair selected"
                 :
                 SeatData.Y == 1 && data.PassengerInfo == "MALE" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                   "maxseat male selected"
                   :
                   SeatData.Y == 1 && data.PassengerInfo == "MALEWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                     "maxseat maleWithChild selected" // need to change the image class
                     :
                     SeatData.Y == 1 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                       "maxseat maleWheelChairWithInfant selected"
                       :
                       SeatData.Y == 1 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                         "maxseat maleChildWheelChair selected"
                         :
                         SeatData.Y == 1 && data.PassengerInfo == "MALECHILD" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                           "maxseat maleChild selected"
                           :
                           SeatData.Y == 1 && data.PassengerInfo == "MALECHILDWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                             "maxseat maleWithChild selected" // need to change the image class
                             :
                             SeatData.Y == 1 && data.PassengerInfo == "FEMALEWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                               "maxseat femaleWheelChairWithInfant selected"
                               :
                               SeatData.Y == 1 && data.PassengerInfo == "FEMALEWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                 "maxseat femaleWheelChair selected"
                                 :
                                 SeatData.Y == 1 && data.PassengerInfo == "FEMALE" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                   "maxseat female selected"
                                   :
                                   SeatData.Y == 1 && data.PassengerInfo == "FEMALEWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                     "maxseat femaleWithInfant selected"
                                     :
                                     SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                       "maxseat femaleWheelChairWithInfant selected"
                                       :
                                       SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                         "maxseat femaleChildWheelChair selected"
                                         :
                                         SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILD" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                           "maxseat femaleChild selected"
                                           :
                                           SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILDWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                             "maxseat femaleWithInfant selected"
                                             :
                                             SeatData.Y == 0 && data.PassengerInfo == "MALEWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                               "maleWheelChairWithInfant selected"
                                               :
                                               SeatData.Y == 0 && data.PassengerInfo == "MALEWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                 "maleWheelChair selected"
                                                 :
                                                 SeatData.Y == 0 && data.PassengerInfo == "MALE" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                   "male selected"
                                                   :
                                                   SeatData.Y == 0 && data.PassengerInfo == "MALEWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                     "maleWithChild selected" // need to change the image class
                                                     :
                                                     SeatData.Y == 0 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                       "maleWheelChairWithInfant selected"
                                                       :
                                                       SeatData.Y == 0 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                         "maleChildWheelChair selected"
                                                         :
                                                         SeatData.Y == 0 && data.PassengerInfo == "MALECHILD" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                           "maleChild selected"
                                                           :
                                                           SeatData.Y == 0 && data.PassengerInfo == "MALECHILDWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                             "maleWithChild selected" // need to change the image class
                                                             :
                                                             SeatData.Y == 0 && data.PassengerInfo == "FEMALEWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                               "femaleWheelChairWithInfant selected"
                                                               :
                                                               SeatData.Y == 0 && data.PassengerInfo == "FEMALEWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                                 "femaleWheelChair selected"
                                                                 :
                                                                 SeatData.Y == 0 && data.PassengerInfo == "FEMALE" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                                   "female selected"
                                                                   :
                                                                   SeatData.Y == 0 && data.PassengerInfo == "FEMALEWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                                     "femaleWithInfant selected"
                                                                     :
                                                                     SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                                       "femaleWheelChairWithInfant selected"
                                                                       :
                                                                       SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                                         "femaleChildWheelChair selected"
                                                                         :
                                                                         SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILD" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                                           "femaleChild selected"
                                                                           :
                                                                           SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILDWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                                             "femaleWithInfant selected"
                                                                             :
                                                                             SeatData.Y == 1 && data.PassengerInfo == "MALEWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                               "maxseat maleWheelChairWithInfant"
                                                                               :
                                                                               SeatData.Y == 1 && data.PassengerInfo == "MALEWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                 "maxseat maleWheelChair"
                                                                                 :
                                                                                 SeatData.Y == 1 && data.PassengerInfo == "MALE" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                   "maxseat male"
                                                                                   :
                                                                                   SeatData.Y == 1 && data.PassengerInfo == "MALEWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                     "maxseat maleWithChild" // need to change the image class
                                                                                     :
                                                                                     SeatData.Y == 1 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                       "maxseat maleWheelChairWithInfant"
                                                                                       :
                                                                                       SeatData.Y == 1 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                         "maxseat maleChildWheelChair"
                                                                                         :
                                                                                         SeatData.Y == 1 && data.PassengerInfo == "MALECHILD" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                           "maxseat maleChild"
                                                                                           :
                                                                                           SeatData.Y == 1 && data.PassengerInfo == "MALECHILDWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                             "maxseat maleWithChild" // need to change the image class
                                                                                             :
                                                                                             SeatData.Y == 1 && data.PassengerInfo == "FEMALEWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                               "maxseat femaleWheelChairWithInfant"
                                                                                               :
                                                                                               SeatData.Y == 1 && data.PassengerInfo == "FEMALEWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                 "maxseat femaleWheelChair"
                                                                                                 :
                                                                                                 SeatData.Y == 1 && data.PassengerInfo == "FEMALE" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                   "maxseat female"
                                                                                                   :
                                                                                                   SeatData.Y == 1 && data.PassengerInfo == "FEMALEWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                     "maxseat femaleWithInfant"
                                                                                                     :
                                                                                                     SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                       "maxseat femaleWheelChairWithInfant"
                                                                                                       :
                                                                                                       SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                         "maxseat femaleChildWheelChair"
                                                                                                         :
                                                                                                         SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILD" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                           "maxseat femaleChild"
                                                                                                           :
                                                                                                           SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILDWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                             "maxseat femaleWithInfant"
                                                                                                             :
                                                                                                             SeatData.Y == 0 && data.PassengerInfo == "MALEWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                               "maleWheelChairWithInfant"
                                                                                                               :
                                                                                                               SeatData.Y == 0 && data.PassengerInfo == "MALEWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                 "maleWheelChair"
                                                                                                                 :
                                                                                                                 SeatData.Y == 0 && data.PassengerInfo == "MALE" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                   "male"
                                                                                                                   :
                                                                                                                   SeatData.Y == 0 && data.PassengerInfo == "MALEWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                     "maleWithChild" // need to change the image class
                                                                                                                     :
                                                                                                                     SeatData.Y == 0 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                       "maleWheelChairWithInfant"
                                                                                                                       :
                                                                                                                       SeatData.Y == 0 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                         "maleChildWheelChair"
                                                                                                                         :
                                                                                                                         SeatData.Y == 0 && data.PassengerInfo == "MALECHILD" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                           "maleChild"
                                                                                                                           :
                                                                                                                           SeatData.Y == 0 && data.PassengerInfo == "MALECHILDWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                             "maleWithChild" // need to change the image class
                                                                                                                             :
                                                                                                                             SeatData.Y == 0 && data.PassengerInfo == "FEMALEWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                               "femaleWheelChairWithInfant"
                                                                                                                               :
                                                                                                                               SeatData.Y == 0 && data.PassengerInfo == "FEMALEWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                                 "femaleWheelChair"
                                                                                                                                 :
                                                                                                                                 SeatData.Y == 0 && data.PassengerInfo == "FEMALE" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                                   "female"
                                                                                                                                   :
                                                                                                                                   SeatData.Y == 0 && data.PassengerInfo == "FEMALEWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                                     "femaleWithInfant"
                                                                                                                                     :
                                                                                                                                     SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                                       "femaleWheelChairWithInfant"
                                                                                                                                       :
                                                                                                                                       SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                                         "femaleChildWheelChair"
                                                                                                                                         :
                                                                                                                                         SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILD" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                                           "femaleChild"
                                                                                                                                           :
                                                                                                                                           SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILDWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                                             "femaleWithInfant"
                                                                                                                                             : "")
             :
             SeatData.PNRPassenger == true ?
               SeatData.Y == 1 && SeatData.PNRPassengerGender == "MALEWITHWHEELCHAIRANDINFT" ?
                 "maxseat maleWheelChairWithInfant"
                 :
                 SeatData.Y == 1 && SeatData.PNRPassengerGender == "MALEWITHWHEELCHAIR" ?
                   "maxseat maleWheelChair"
                   :
                   SeatData.Y == 1 && SeatData.PNRPassengerGender == "MALE" ?
                     "maxseat male"
                     :
                     SeatData.Y == 1 && SeatData.PNRPassengerGender == "MALEWITHINFANT" ?
                       "maxseat maleWithChild" // need to change the image class
                       :
                       SeatData.Y == 1 && SeatData.PNRPassengerGender == "MALECHILDWITHWHEELCHAIRANDINFT" ?
                         "maxseat maleWheelChairWithInfant"
                         :
                         SeatData.Y == 1 && SeatData.PNRPassengerGender == "MALECHILDWITHWHEELCHAIR" ?
                           "maxseat maleChildWheelChair"
                           :
                           SeatData.Y == 1 && SeatData.PNRPassengerGender == "MALECHILD" ?
                             "maxseat maleChild"
                             :
                             SeatData.Y == 1 && SeatData.PNRPassengerGender == "MALECHILDWITHINFANT" ?
                               "maxseat maleWithChild" // need to change the image class
                               :
                               SeatData.Y == 1 && SeatData.PNRPassengerGender == "FEMALEWITHWHEELCHAIRANDINFT" ?
                                 "maxseat femaleWheelChairWithInfant"
                                 :
                                 SeatData.Y == 1 && SeatData.PNRPassengerGender == "FEMALEWITHWHEELCHAIR" ?
                                   "maxseat femaleWheelChair"
                                   :
                                   SeatData.Y == 1 && SeatData.PNRPassengerGender == "FEMALE" ?
                                     "maxseat female"
                                     :
                                     SeatData.Y == 1 && SeatData.PNRPassengerGender == "FEMALEWITHINFANT" ?
                                       "maxseat femaleWithInfant"
                                       :
                                       SeatData.Y == 1 && SeatData.PNRPassengerGender == "FEMALECHILDWITHWHEELCHAIRANDINFT" ?
                                         "maxseat femaleWheelChairWithInfant"
                                         :
                                         SeatData.Y == 1 && SeatData.PNRPassengerGender == "FEMALECHILDWITHWHEELCHAIR" ?
                                           "maxseat femaleChildWheelChair"
                                           :
                                           SeatData.Y == 1 && SeatData.PNRPassengerGender == "FEMALECHILD" ?
                                             "maxseat femaleChild"
                                             :
                                             SeatData.Y == 1 && SeatData.PNRPassengerGender == "FEMALECHILDWITHINFANT" ?
                                               "maxseat femaleWithInfant"
                                               :
                                               SeatData.Y == 0 && SeatData.PNRPassengerGender == "MALEWITHWHEELCHAIRANDINFT" ?
                                                 "maleWheelChairWithInfant"
                                                 :
                                                 SeatData.Y == 0 && SeatData.PNRPassengerGender == "MALEWITHWHEELCHAIR" ?
                                                   "maleWheelChair"
                                                   :
                                                   SeatData.Y == 0 && SeatData.PNRPassengerGender == "MALE" ?
                                                     "male"
                                                     :
                                                     SeatData.Y == 0 && SeatData.PNRPassengerGender == "MALEWITHINFANT" ?
                                                       "maleWithChild" // need to change the image class
                                                       :
                                                       SeatData.Y == 0 && SeatData.PNRPassengerGender == "MALECHILDWITHWHEELCHAIRANDINFT" ?
                                                         "maleWheelChairWithInfant"
                                                         :
                                                         SeatData.Y == 0 && SeatData.PNRPassengerGender == "MALECHILDWITHWHEELCHAIR" ?
                                                           "maleChildWheelChair"
                                                           :
                                                           SeatData.Y == 0 && SeatData.PNRPassengerGender == "MALECHILD" ?
                                                             "maleChild"
                                                             :
                                                             SeatData.Y == 0 && SeatData.PNRPassengerGender == "MALECHILDWITHINFANT" ?
                                                               "maleWithChild" // need to change the image class
                                                               :
                                                               SeatData.Y == 0 && SeatData.PNRPassengerGender == "FEMALEWITHWHEELCHAIRANDINFT" ?
                                                                 "femaleWheelChairWithInfant"
                                                                 :
                                                                 SeatData.Y == 0 && SeatData.PNRPassengerGender == "FEMALEWITHWHEELCHAIR" ?
                                                                   "femaleWheelChair"
                                                                   :
                                                                   SeatData.Y == 0 && SeatData.PNRPassengerGender == "FEMALE" ?
                                                                     "female"
                                                                     :
                                                                     SeatData.Y == 0 && SeatData.PNRPassengerGender == "FEMALEWITHINFANT" ?
                                                                       "femaleWithInfant"
                                                                       :
                                                                       SeatData.Y == 0 && SeatData.PNRPassengerGender == "FEMALECHILDWITHWHEELCHAIRANDINFT" ?
                                                                         "femaleWheelChairWithInfant"
                                                                         :
                                                                         SeatData.Y == 0 && SeatData.PNRPassengerGender == "FEMALECHILDWITHWHEELCHAIR" ?
                                                                           "femaleChildWheelChair"
                                                                           :
                                                                           SeatData.Y == 0 && SeatData.PNRPassengerGender == "FEMALECHILD" ?
                                                                             "femaleChild"
                                                                             :
                                                                             SeatData.Y == 0 && SeatData.PNRPassengerGender == "FEMALECHILDWITHINFANT" ?
                                                                               "femaleWithInfant"
                                                                               : "" :
               SeatData.Y == 1 ?
                 "maxseat checkin"
                 :
                 SeatData.Y == 0 ?
                   "checkin"
                   :
                   ""
       
           if (seatIdentificationData.length) {
             const { journeyKey, segmentKey } = selectedPassengerAndSegment;
             const selectedJourney = SearchedFlightDetails.journeys.filter(j => j.journeyKey === journeyKey);
             const selectedSeg = selectedJourney.length && selectedJourney[0].segments.filter(s => s.segmentKey === segmentKey && s.IsSelected);
             let isInfant = false;
             let isWheelchair = false;
             let isUNMR = false;
       
             if (selectedSeg.length > 0) {
               let ssrLeg = [];
               let allSSRBlockedSeats = [];
               selectedSeg[0].legs.forEach(leg => {
                 ssrLeg = seatIdentificationData.filter(si => si.legkey === leg.legKey);
       
               })
               if(ssrLeg.length) {
                 isInfant = ssrLeg[0].rownoInfant.some(i => i === SeatData.SeatDesignator);
                 isWheelchair = ssrLeg[0].rownoWheelchair.some(i => i === SeatData.SeatDesignator);
                 isUNMR = ssrLeg[0].rownoUNMR.some(i => i === SeatData.SeatDesignator);
               }
             }
             if (SeatData.Status == "CheckedIn") {
       
               if (isInfant) {
                 cls = SeatData.Y == 1 ? 'maxInfantCheckedin' : 'normalInfantCheckedin';
               }
               if (isWheelchair) {
                 cls = SeatData.Y == 1 ? 'maxWheelchairCheckedin' : 'normalWheelchairCheckedin';
               }
               if (isUNMR) {
                 cls = SeatData.Y == 1 ? 'maxUNMRCheckedin' : 'normalUNMRCheckedin';
               }
             }
           }
           return cls.toString().replaceAll(',', '')
       
         }
       
         function ssrsOnOtherSeats(SeatData) {
           const { journeyKey, segmentKey } = selectedPassengerAndSegment;
           const selectedJourney = SearchedFlightDetails.journeys.filter(j => j.journeyKey === journeyKey);
           const selectedSeg = selectedJourney.length && selectedJourney[0].segments.filter(s => s.segmentKey === segmentKey && s.IsSelected);
       
           // debugger
           let maxClass = '', normalClass = '';
           if (SeatData.Status === 'Reserved') {
             maxClass = 'maxseat reservedSeat';
             normalClass = 'reservedSeat';
           }
           if (SeatData.Status === 'HeldForAnotherSession') {
             maxClass = 'maxseat heldForAnotherSession';
             normalClass = 'heldForAnotherSession';
           }
       
           if (seatIdentificationData.length) {
             let isInfant = false;
             let isWheelchair = false;
             let isUNMR = false;
       
             if (selectedSeg.length > 0) {
               let ssrLeg = [];
               let allSSRBlockedSeats = [];
               selectedSeg[0].legs.forEach(leg => {
                 ssrLeg = seatIdentificationData.filter(si => si.legkey === leg.legKey);
       
               })
               if(ssrLeg.length) {
                 isInfant = ssrLeg[0].rownoInfant.some(i => i === SeatData.SeatDesignator);
                 isWheelchair = ssrLeg[0].rownoWheelchair.some(i => i === SeatData.SeatDesignator);
                 isUNMR = ssrLeg[0].rownoUNMR.some(i => i === SeatData.SeatDesignator);
               }
             }
             if (SeatData.Status === "Reserved") {
       
               if (isInfant) {
                 maxClass = 'maxInfantReserved';
                 normalClass = 'normalInfantReserved';
               }
               if (isWheelchair) {
                 maxClass = 'maxWheelchairReserved';
                 normalClass = 'normalWheelchairReserved';
               }
               if (isUNMR) {
                 maxClass = 'maxUNMRReserved';
                 normalClass = 'normalUNMRReserved';
               }
             }
             if (SeatData.Status === 'HeldForAnotherSession') {
               if (isInfant) {
                 maxClass = 'maxInfantHeldForAnotherSession';
                 normalClass = 'normalInfantHeldForAnotherSession';
               }
               if (isWheelchair) {
                 maxClass = 'maxWheelchairHeldForAnotherSession';
                 normalClass = 'normalWheelchairHeldForAnotherSession';
               }
               if (isUNMR) {
                 maxClass = 'maxUNMRHeldForAnotherSession';
                 normalClass = 'normalUNMRHeldForAnotherSession';
               }
             }
           }
       
           return (
             <div>
               <input class={SeatData.Y == 1 ? maxClass : normalClass} type="checkbox" tabIndex={-1}/>
               <label>{SeatData.SeatDesignator ? SeatData.SeatDesignator : ""}tabIndex={-1}</label>
             </div>
           );
       
         }
       
         function elementReservedForPnr(SeatData, data) {
           const cls = fncCheckPassengerCheckedInStatus(SeatData.SeatDesignator) && SeatData.PNRPassenger == true ? st_UserSeatDetails.length == 0 ? "" : st_UserSeatDetails.map((data) =>
             // data.SelectedPassenger ? "selected" : 
             SeatData.Y == 1 && data.PassengerInfo == "MALEWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
               "maxseat maleWheelChairWithInfant selected"
               :
               SeatData.Y == 1 && data.PassengerInfo == "MALEWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                 "maxseat maleWheelChair selected"
                 :
                 SeatData.Y == 1 && data.PassengerInfo == "MALE" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                   "maxseat male selected"
                   :
                   SeatData.Y == 1 && data.PassengerInfo == "MALEWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                     "maxseat maleWithChild selected" // need to change the image class
                     :
                     SeatData.Y == 1 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                       "maxseat maleWheelChairWithInfant selected"
                       :
                       SeatData.Y == 1 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                         "maxseat maleChildWheelChair selected"
                         :
                         SeatData.Y == 1 && data.PassengerInfo == "MALECHILD" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                           "maxseat maleChild selected"
                           :
                           SeatData.Y == 1 && data.PassengerInfo == "MALECHILDWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                             "maxseat maleWithChild selected" // need to change the image class
                             :
                             SeatData.Y == 1 && data.PassengerInfo == "FEMALEWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                               "maxseat femaleWheelChairWithInfant selected"
                               :
                               SeatData.Y == 1 && data.PassengerInfo == "FEMALEWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                 "maxseat femaleWheelChair selected"
                                 :
                                 SeatData.Y == 1 && data.PassengerInfo == "FEMALE" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                   "maxseat female selected"
                                   :
                                   SeatData.Y == 1 && data.PassengerInfo == "FEMALEWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                     "maxseat femaleWithInfant selected"
                                     :
                                     SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                       "maxseat femaleWheelChairWithInfant selected"
                                       :
                                       SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                         "maxseat femaleChildWheelChair selected"
                                         :
                                         SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILD" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                           "maxseat femaleChild selected"
                                           :
                                           SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILDWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                             "maxseat femaleWithInfant selected"
                                             :
                                             SeatData.Y == 0 && data.PassengerInfo == "MALEWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                               "maleWheelChairWithInfant selected"
                                               :
                                               SeatData.Y == 0 && data.PassengerInfo == "MALEWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                 "maleWheelChair selected"
                                                 :
                                                 SeatData.Y == 0 && data.PassengerInfo == "MALE" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                   "male selected"
                                                   :
                                                   SeatData.Y == 0 && data.PassengerInfo == "MALEWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                     "maleWithChild selected" // need to change the image class
                                                     :
                                                     SeatData.Y == 0 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                       "maleWheelChairWithInfant selected"
                                                       :
                                                       SeatData.Y == 0 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                         "maleChildWheelChair selected"
                                                         :
                                                         SeatData.Y == 0 && data.PassengerInfo == "MALECHILD" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                           "maleChild selected"
                                                           :
                                                           SeatData.Y == 0 && data.PassengerInfo == "MALECHILDWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                             "maleWithChild selected" // need to change the image class
                                                             :
                                                             SeatData.Y == 0 && data.PassengerInfo == "FEMALEWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                               "femaleWheelChairWithInfant selected"
                                                               :
                                                               SeatData.Y == 0 && data.PassengerInfo == "FEMALEWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                                 "femaleWheelChair selected"
                                                                 :
                                                                 SeatData.Y == 0 && data.PassengerInfo == "FEMALE" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                                   "female selected"
                                                                   :
                                                                   SeatData.Y == 0 && data.PassengerInfo == "FEMALEWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                                     "femaleWithInfant selected"
                                                                     :
                                                                     SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                                       "femaleWheelChairWithInfant selected"
                                                                       :
                                                                       SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                                         "femaleChildWheelChair selected"
                                                                         :
                                                                         SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILD" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                                           "femaleChild selected"
                                                                           :
                                                                           SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILDWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
                                                                             "femaleWithInfant selected"
                                                                             :
                                                                             SeatData.Y == 1 && data.PassengerInfo == "MALEWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                               "maxseat maleWheelChairWithInfant"
                                                                               :
                                                                               SeatData.Y == 1 && data.PassengerInfo == "MALEWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                 "maxseat maleWheelChair"
                                                                                 :
                                                                                 SeatData.Y == 1 && data.PassengerInfo == "MALE" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                   "maxseat male"
                                                                                   :
                                                                                   SeatData.Y == 1 && data.PassengerInfo == "MALEWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                     "maxseat maleWithChild" // need to change the image class
                                                                                     :
                                                                                     SeatData.Y == 1 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                       "maxseat maleWheelChairWithInfant"
                                                                                       :
                                                                                       SeatData.Y == 1 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                         "maxseat maleChildWheelChair"
                                                                                         :
                                                                                         SeatData.Y == 1 && data.PassengerInfo == "MALECHILD" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                           "maxseat maleChild"
                                                                                           :
                                                                                           SeatData.Y == 1 && data.PassengerInfo == "MALECHILDWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                             "maxseat maleWithChild" // need to change the image class
                                                                                             :
                                                                                             SeatData.Y == 1 && data.PassengerInfo == "FEMALEWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                               "maxseat femaleWheelChairWithInfant"
                                                                                               :
                                                                                               SeatData.Y == 1 && data.PassengerInfo == "FEMALEWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                 "maxseat femaleWheelChair"
                                                                                                 :
                                                                                                 SeatData.Y == 1 && data.PassengerInfo == "FEMALE" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                   "maxseat female"
                                                                                                   :
                                                                                                   SeatData.Y == 1 && data.PassengerInfo == "FEMALEWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                     "maxseat femaleWithInfant"
                                                                                                     :
                                                                                                     SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                       "maxseat femaleWheelChairWithInfant"
                                                                                                       :
                                                                                                       SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                         "maxseat femaleChildWheelChair"
                                                                                                         :
                                                                                                         SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILD" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                           "maxseat femaleChild"
                                                                                                           :
                                                                                                           SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILDWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                             "maxseat femaleWithInfant"
                                                                                                             :
                                                                                                             SeatData.Y == 0 && data.PassengerInfo == "MALEWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                               "maleWheelChairWithInfant"
                                                                                                               :
                                                                                                               SeatData.Y == 0 && data.PassengerInfo == "MALEWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                 "maleWheelChair"
                                                                                                                 :
                                                                                                                 SeatData.Y == 0 && data.PassengerInfo == "MALE" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                   "male"
                                                                                                                   :
                                                                                                                   SeatData.Y == 0 && data.PassengerInfo == "MALEWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                     "maleWithChild" // need to change the image class
                                                                                                                     :
                                                                                                                     SeatData.Y == 0 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                       "maleWheelChairWithInfant"
                                                                                                                       :
                                                                                                                       SeatData.Y == 0 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                         "maleChildWheelChair"
                                                                                                                         :
                                                                                                                         SeatData.Y == 0 && data.PassengerInfo == "MALECHILD" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                           "maleChild"
                                                                                                                           :
                                                                                                                           SeatData.Y == 0 && data.PassengerInfo == "MALECHILDWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                             "maleWithChild" // need to change the image class
                                                                                                                             :
                                                                                                                             SeatData.Y == 0 && data.PassengerInfo == "FEMALEWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                               "femaleWheelChairWithInfant"
                                                                                                                               :
                                                                                                                               SeatData.Y == 0 && data.PassengerInfo == "FEMALEWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                                 "femaleWheelChair"
                                                                                                                                 :
                                                                                                                                 SeatData.Y == 0 && data.PassengerInfo == "FEMALE" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                                   "female"
                                                                                                                                   :
                                                                                                                                   SeatData.Y == 0 && data.PassengerInfo == "FEMALEWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                                     "femaleWithInfant"
                                                                                                                                     :
                                                                                                                                     SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                                       "femaleWheelChairWithInfant"
                                                                                                                                       :
                                                                                                                                       SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                                         "femaleChildWheelChair"
                                                                                                                                         :
                                                                                                                                         SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILD" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                                           "femaleChild"
                                                                                                                                           :
                                                                                                                                           SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILDWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL ?
                                                                                                                                             "femaleWithInfant"
                                                                                                                                             : "")
             :
             SeatData.PNRPassenger == true ?
               SeatData.Y == 1 && SeatData.PNRPassengerGender == "MALEWITHWHEELCHAIRANDINFT" ?
                 "maxseat maleWheelChairWithInfant"
                 :
                 SeatData.Y == 1 && SeatData.PNRPassengerGender == "MALEWITHWHEELCHAIR" ?
                   "maxseat maleWheelChair"
                   :
                   SeatData.Y == 1 && SeatData.PNRPassengerGender == "MALE" ?
                     "maxseat male"
                     :
                     SeatData.Y == 1 && SeatData.PNRPassengerGender == "MALEWITHINFANT" ?
                       "maxseat maleWithChild" // need to change the image class
                       :
                       SeatData.Y == 1 && SeatData.PNRPassengerGender == "MALECHILDWITHWHEELCHAIRANDINFT" ?
                         "maxseat maleWheelChairWithInfant"
                         :
                         SeatData.Y == 1 && SeatData.PNRPassengerGender == "MALECHILDWITHWHEELCHAIR" ?
                           "maxseat maleChildWheelChair"
                           :
                           SeatData.Y == 1 && SeatData.PNRPassengerGender == "MALECHILD" ?
                             "maxseat maleChild"
                             :
                             SeatData.Y == 1 && SeatData.PNRPassengerGender == "MALECHILDWITHINFANT" ?
                               "maxseat maleWithChild" // need to change the image class
                               :
                               SeatData.Y == 1 && SeatData.PNRPassengerGender == "FEMALEWITHWHEELCHAIRANDINFT" ?
                                 "maxseat femaleWheelChairWithInfant"
                                 :
                                 SeatData.Y == 1 && SeatData.PNRPassengerGender == "FEMALEWITHWHEELCHAIR" ?
                                   "maxseat femaleWheelChair"
                                   :
                                   SeatData.Y == 1 && SeatData.PNRPassengerGender == "FEMALE" ?
                                     "maxseat female"
                                     :
                                     SeatData.Y == 1 && SeatData.PNRPassengerGender == "FEMALEWITHINFANT" ?
                                       "maxseat femaleWithInfant"
                                       :
                                       SeatData.Y == 1 && SeatData.PNRPassengerGender == "FEMALECHILDWITHWHEELCHAIRANDINFT" ?
                                         "maxseat femaleWheelChairWithInfant"
                                         :
                                         SeatData.Y == 1 && SeatData.PNRPassengerGender == "FEMALECHILDWITHWHEELCHAIR" ?
                                           "maxseat femaleChildWheelChair"
                                           :
                                           SeatData.Y == 1 && SeatData.PNRPassengerGender == "FEMALECHILD" ?
                                             "maxseat femaleChild"
                                             :
                                             SeatData.Y == 1 && SeatData.PNRPassengerGender == "FEMALECHILDWITHINFANT" ?
                                               "maxseat femaleWithInfant"
                                               :
                                               SeatData.Y == 0 && SeatData.PNRPassengerGender == "MALEWITHWHEELCHAIRANDINFT" ?
                                                 "maleWheelChairWithInfant"
                                                 :
                                                 SeatData.Y == 0 && SeatData.PNRPassengerGender == "MALEWITHWHEELCHAIR" ?
                                                   "maleWheelChair"
                                                   :
                                                   SeatData.Y == 0 && SeatData.PNRPassengerGender == "MALE" ?
                                                     "male"
                                                     :
                                                     SeatData.Y == 0 && SeatData.PNRPassengerGender == "MALEWITHINFANT" ?
                                                       "maleWithChild" // need to change the image class
                                                       :
                                                       SeatData.Y == 0 && SeatData.PNRPassengerGender == "MALECHILDWITHWHEELCHAIRANDINFT" ?
                                                         "maleWheelChairWithInfant"
                                                         :
                                                         SeatData.Y == 0 && SeatData.PNRPassengerGender == "MALECHILDWITHWHEELCHAIR" ?
                                                           "maleChildWheelChair"
                                                           :
                                                           SeatData.Y == 0 && SeatData.PNRPassengerGender == "MALECHILD" ?
                                                             "maleChild"
                                                             :
                                                             SeatData.Y == 0 && SeatData.PNRPassengerGender == "MALECHILDWITHINFANT" ?
                                                               "maleWithChild" // need to change the image class
                                                               :
                                                               SeatData.Y == 0 && SeatData.PNRPassengerGender == "FEMALEWITHWHEELCHAIRANDINFT" ?
                                                                 "femaleWheelChairWithInfant"
                                                                 :
                                                                 SeatData.Y == 0 && SeatData.PNRPassengerGender == "FEMALEWITHWHEELCHAIR" ?
                                                                   "femaleWheelChair"
                                                                   :
                                                                   SeatData.Y == 0 && SeatData.PNRPassengerGender == "FEMALE" ?
                                                                     "female"
                                                                     :
                                                                     SeatData.Y == 0 && SeatData.PNRPassengerGender == "FEMALEWITHINFANT" ?
                                                                       "femaleWithInfant"
                                                                       :
                                                                       SeatData.Y == 0 && SeatData.PNRPassengerGender == "FEMALECHILDWITHWHEELCHAIRANDINFT" ?
                                                                         "femaleWheelChairWithInfant"
                                                                         :
                                                                         SeatData.Y == 0 && SeatData.PNRPassengerGender == "FEMALECHILDWITHWHEELCHAIR" ?
                                                                           "femaleChildWheelChair"
                                                                           :
                                                                           SeatData.Y == 0 && SeatData.PNRPassengerGender == "FEMALECHILD" ?
                                                                             "femaleChild"
                                                                             :
                                                                             SeatData.Y == 0 && SeatData.PNRPassengerGender == "FEMALECHILDWITHINFANT" ?
                                                                               "femaleWithInfant"
                                                                               : "" :
               SeatData.Y == 1 ?
                 "maxseat"
                 :
                 "";
       
           return (
             <div>
               <input tabIndex={-1}
                 type="checkbox"
                 class={cls.toString().replaceAll(',', '')}
               />
               <label tabIndex={-1} onClick={() => !SeatData.PNRPassenger ? fncSeatSelection(SeatData, "SEATMAP", data.id) : null}>{SeatData.SeatDesignator ? SeatData.SeatDesignator : ""}</label>
             </div>
           )
         }
       
         const fncNextSeat=()=> {
       
           var navPage = fncPageNavigations(UserRights, "Seat", SearchedFlightDetails)
           history.push("/" + navPage);
         }
       
         function handleOnFocus(e) {
           console.log('handleOnFocus----', e.target.id)
           // document.getElementById(e.target.id).setAttribute("style","border:3px solid #F9A81A");
         }
      
  
  
  
       // update 1/3/25 for move to next & prev
       // when we press tabkey it handles keydown
       const handleKeyDown = (e) => {  };
        //1/8
       // for back page ctrl+arrLeft
       useEffect(() => {
         const handleKeyDown = (e) => {
           if (e.ctrlKey && e.key === "ArrowLeft") {
             history.goBack();
           }
         };  
           document.addEventListener("keydown", handleKeyDown);  
         return () => {
           document.removeEventListener("keydown", handleKeyDown);
         };
       }, [history]);
  
   // for next page ctrl+arrnext && shift+R to right div && shift+L for left div shift+up for leftup div
       useEffect(() => {
         const handleKeyDown = (e) => {
           if (e.altKey && e.key.toLowerCase() === 'c') {
                  if(!IsModulAndLoginDivDisabled){
                                             dispatch(moduleAndLoginDivDisabled({
                                                  type: "MODULE_AND_LOGINDIV_DISABLED",
                                                  IsModulAndLoginDivDisabled: true
                                              }));             
                                              console.log(location.pathname,"location.pathname");
                          fncFocusElementDependsOnPathLocation(location.pathname,inputElementForSeat.current[activeleftChildIndex]);
                          setFocusedDiv("left");
                      }else if (IsModulAndLoginDivDisabled) {
                                      const headingDiv = document.querySelector(".modulebtn");            
                                      if (headingDiv) {                  
                                          headingDiv.focus();
                                          dispatch(moduleAndLoginDivDisabled({
                                                  type: "MODULE_AND_LOGINDIV_DISABLED",
                                                  IsModulAndLoginDivDisabled: false
                                              }));
                                      }
                                  }
          }
          else if (e.shiftKey && e.key === "ArrowRight") {
                setleftupdiv(false);
             e.preventDefault();
             setFocusedDiv("right");
             rightSeatsDivRef.current[activeIndex].focus(); 
             console.log(activeIndex ,"activeIndex right");
          }
          else  if (e.shiftKey && e.key === "ArrowLeft") {
             e.preventDefault();
             setFocusedDiv("left");
             inputElementForSeat.current[activeleftChildIndex].focus();      
           }
           else if (e.shiftKey && e.key === "ArrowUp") {
              setleftupdiv(true)
             e.preventDefault(); 
               seg_Unassign_jumpref.current.focus();
               console.log(activeIndex ,"activeleftChildIndex leftup")
               setFocusedDiv("");
           }else 
           if (e.shiftKey && e.key === "ArrowDown") {
            if(leftupdiv){
              setleftupdiv(false)
              e.preventDefault();
              setFocusedDiv("left");
              inputElementForSeat.current[activeleftChildIndex].focus(); 
            }
         }
           else
            if (e.key === "ArrowUp") {
              if(focusedDiv === "right"){
              // setActiveIndex((prevIndex) => {
              //  const newIndex = Math.max(prevIndex - 1, 0);
              //  const targetDiv = rightSeatsDivRef.current[newIndex];
              //  return newIndex;
              // });
              setActiveIndex((prevIndex) => {
                const rows = rightSeatsDivRef.current;
                let newIndex = prevIndex;
      
                while (newIndex > 0) {
                  newIndex--;
                  const prevDiv = rows[newIndex];
                  const checkboxes = Array.from(prevDiv?.querySelectorAll("input[type='checkbox'][status='Open']:not(:disabled)"));
      
                  if (checkboxes.length > 0) {
                    prevDiv?.focus();
                    // trapFocus3(e, newIndex, rightSeatsDivRef); // Trap focus inside this div
                    return newIndex; // Move to the first div that has enabled checkboxes with status Open
                  }
                }
      
                return prevIndex; // Stay at the first valid div if no eligible checkboxes are found
              });
  
              // rightSeatsDivRef.current[activeIndex].focus();
              console.log(activeIndex ,"activeIndex Arrowup");
  
              }
              if(focusedDiv === "left"){
               setActiveleftChildIndex((prevIndex) => {
                const newIndex = Math.max(prevIndex - 1, 0);
                const targetDiv = inputElementForSeat.current[newIndex];
                if (targetDiv) {
                 targetDiv.focus();              
                 const checkboxes = Array.from(targetDiv.querySelectorAll("input[type='checkbox']"));
                   checkboxes.forEach((checkbox, index) => {
                    //dont apply tabindex here it will affect on trapfocus         
                    if (!checkbox.checked) {
                       checkbox.click(); 
                     }
                   });        
               }
                return newIndex;
               });
               }
            } 
            else if (e.key === "ArrowDown" ) {
             if(focusedDiv === "right"){
               e.preventDefault();
               // updated for if not any checkbox it enabled
                setActiveIndex((prevIndex) => {
                const rows = rightSeatsDivRef.current;
                let newIndex = prevIndex;    
                while (newIndex < rows.length - 1) {
                  newIndex++;
                  const nextDiv = rows[newIndex];
                  const checkboxes = Array.from(nextDiv?.querySelectorAll("input[type='checkbox'][status='Open']:not(:disabled)"));    
                  if (checkboxes.length > 0) {
                    nextDiv?.focus();
                    // trapFocus3(e, newIndex, rightSeatsDivRef);
                    return newIndex; // Move to the first div that has enabled checkboxes with status Open
                  }
                }
      
                return prevIndex; // Stay at the last valid div if no eligible checkboxes are found
              });
              console.log(activeIndex, "activeIndex ArrowDown");
      
             }
             if(focusedDiv === "left"){
               e.preventDefault();
              //  debugger
               setActiveleftChildIndex((prevIndex) => {
                 const rows = inputElementForSeat.current;
                const newIndex = Math.min(prevIndex + 1, rows.length-1);
                const targetDiv=inputElementForSeat.current[newIndex];
                if (targetDiv) {
                 targetDiv.focus();              
                 const checkboxes = Array.from(targetDiv.querySelectorAll("input[type='checkbox']"));
                               if (checkboxes.length > 0) {
                   checkboxes.reverse();
                   checkboxes.forEach((checkbox, index) => {
                    //dont apply tabindex here it will affect on trapfocus         
                     if (!checkbox.checked) {
                       checkbox.click(); 
                     }
                   });        
                  //  checkboxes[0].focus();
                 }
               }
                return newIndex;
               });
               }
             }    
             else if (e.ctrlKey && e.key === "ArrowRight") {
             fncNextSeat();
           }    
     
         };
         document.addEventListener("keydown", handleKeyDown);
         return () => {
           document.removeEventListener("keydown", handleKeyDown);
         };
       }, [focusedDiv,IsModulAndLoginDivDisabled,activeleftChildIndex]);
   
        // Focus the active div
      useEffect(() => {
         if ( rightSeatsDivRef.current[activeIndex]) {
           rightSeatsDivRef.current[activeIndex].focus();}
      },[activeIndex]);
       // Focus the active div of left childdiv 
       useEffect(() => {
          if ( inputElementForSeat.current[activeleftChildIndex]) {
                 inputElementForSeat.current[activeleftChildIndex].focus();}
       },[activeleftChildIndex]);
       
  
       // only next pege
       useEffect(() => {
         const handleKeyDown = (e) => {
                if (e.ctrlKey && e.key === "ArrowRight") {
             fncNextSeat();
           }
         };  
           document.addEventListener("keydown", handleKeyDown);
         return () => {
           document.removeEventListener("keydown", handleKeyDown);
         };
       },[fncNextSeat]);
       
     
      // every thing is working good i have used status="open" for trap focus .the problem of loosing focus if last disabledcheckbox resolved
      const trapFocus3 = (e, divIndex, ref) => {
        const currentDiv = ref.current[divIndex];
        if (!currentDiv) return;
      
        // Select only focusable elements where checkboxes have status="open"
        const focusableElements = Array.from(
          currentDiv.querySelectorAll(
            "input[status='open'], [tabindex]:not([tabindex='-1'])"
          )
        );    
        if (focusableElements.length === 0) return; // No valid focusable elements, do nothing
      
        const currentIndex = focusableElements.indexOf(document.activeElement);
      
        if (e.key === "Tab") {
          if (e.shiftKey) {
            // Shift+Tab: Move focus backward
            if (currentIndex > 0) {
              e.preventDefault();
              focusableElements[currentIndex - 1].focus();
            } else {
              // If it's the first element, wrap to the last element
              e.preventDefault();
              focusableElements[focusableElements.length - 1].focus();
            }
          } else {
            // Tab: Move focus forward
            if (currentIndex < focusableElements.length - 1) {
              e.preventDefault();
              focusableElements[currentIndex + 1].focus();
            } else {
              // If it's the last element, wrap to the first element
              e.preventDefault();
              focusableElements[0].focus();
            }
          }
        }
      };
      
      const trapFocus4 = (e, divIndex, ref) => {
        const currentDiv = ref.current[divIndex];
        if (!currentDiv) return;
      
        // Get all focusable elements inside the div
        const focusableElements = Array.from(
          currentDiv.querySelectorAll(
            "input, button, textarea, a[href], [tabindex]:not([tabindex='-1'])"
          )
        );
      
        if (focusableElements.length === 0) return; // No focusable elements, do nothing
      
        // const firstElement = focusableElements[0];when we press shift+Tab it is loosing focus  focused div  
        // const firstElement = focusableElements[1]; //making 0 to 1 when we press shift+Tab it is traping focus inside rightside focused div but loosing focus to leftside div input 
        const firstElement = focusableElements[0]
        const lastElement = focusableElements[focusableElements.length - 1];
      
        if (e.key === "Tab") {
          // if (e.shiftKey && document.activeElement === firstElement) {
          //   // If Shift+Tab is pressed on first element, move focus to last
          //   e.preventDefault();
          //   lastElement.focus();
          // } 
          // else
          //  if (!e.shiftKey && document.activeElement === lastElement) {
           if ( document.activeElement === lastElement) {
            // If Tab is pressed on last element, move focus to first
            e.preventDefault();
            firstElement.focus();
          }
         
        }
         if (e.shiftKey && e.key === "Tab" ) {
          if (document.activeElement === firstElement) {
            e.preventDefault();
            firstElement.focus();
          }
        }
      };
  
      // trap focus for Seat Assignments div
      const trapFocus1 = (e, ref) => {
        if (!ref.current) return;      
        // Dynamically get only enabled buttons and other focusable elements
        const focusableElements = Array.from(
          ref.current.querySelectorAll('input, button:not(:disabled), textarea, a[href], [tabindex]:not([tabindex="-1"])')
        ).filter(el => !el.disabled);
      
        const enabledButtons = focusableElements.filter(el => el.tagName === "BUTTON");
      
        if (focusableElements.length === 0) return;
      
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
      
        console.log(`Enabled Buttons Count: ${enabledButtons.length}`);
      
        if (e.key === "Tab") {
          if (e.shiftKey && document.activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus(); // Shift + Tab: move to last focusable element
          } else if (!e.shiftKey && document.activeElement === lastElement) {
            e.preventDefault();
            firstElement.focus(); // Tab: move back to first focusable element
          }
        }
      };
  
  
    const handleInputChange = (e) => {
      const { value } = e.target;
      setSeatFromUserInput(value);
    };
   
    useEffect(() => {
      debugger
      if(showErrorPopup){
        document.addEventListener("keyup", function (event) {      
    
          if (event.key === "Enter" && show ) {
            okbutton.current.focus();
              handleCloseshowErrorPopup();
            // settriggercheck(true);
          }
        });
      }    
    }, [showErrorPopup]);
    
    useEffect(() => {
      if (showErrorPopup) {
        okbutton.current.focus();
          // const target = 
          // document.getElementById("okbtnSeats").focus();
          // if (target) {
          //     target.focus();
          // }
      }
  }, [showErrorPopup]);
  useEffect(() => {
    if (show) {
            yesbutton.current?.focus();
    }
  }, [show]);
  
  useEffect(() => {
            if (showSSRSeatNotAvailableErrorPopup) {
              okbutton1.current?.focus();
            }
    }, [showSSRSeatNotAvailableErrorPopup]);
  
    useEffect(() => {
            if (showWaiveFeeModal) {
                    waveReasonSelest.current?.focus();
            }
    }, [showWaiveFeeModal]);
    // move focus to yes btn
     useEffect(() => {
            const handleKeyDown = (e) => {
            if (e.key === "Tab") {
           if (
            document.activeElement.id === "noOnAutoAssignSeat" && 
            !e.shiftKey
          ) {
            e.preventDefault();
            yesbutton.current?.focus(); // Move focus to the yes button
          }
           if (
            document.activeElement.id === "waveNoBtn" && 
            !e.shiftKey
          ) {
            e.preventDefault();
            waveReasonSelest.current?.focus();
          }
            }
    }
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
          });

         return (
           <div>
             <LogoutModel trigger={triggerModal}> </LogoutModel>
             <DocumentVerificationModal trigger={!isInternationalFlight(SearchedFlightDetails) && selectedModule === checkinModule && !docVerified && !allCheckedIn && haveTravelDocs(SearchedFlightDetails)}></DocumentVerificationModal>
             {/* //------------------------------------------------------------ FOOTER DATA STARTS HERE-------------------------------------------------------- */}
       
             {/* //------------------------------------------------------------ FOOTER DATA ENDS HERE-------------------------------------------------------- */}
             { /** ------------------------------ Modals start here ------------------------------ */}
             <Modal
               show={show}
               onHide={fncPopupCancelClick}
               backdrop="static"
               keyboard={true}
               className="clsQuickAssign"
             >
               <Modal.Header>
                 <Modal.Title>Auto Assign</Modal.Title>
               </Modal.Header>
               <Modal.Body>
                 Wish to auto assign seats ?
               </Modal.Body>
               <Modal.Footer>
                 <button ref={yesbutton} id="yesOnAutoAssignSeat" className="focusClass btn btn-red OrangeShadow" onClick={fncAutoAssignSeats} onFocus={e => handleOnFocus(e)} >Yes</button>
                 <button id="noOnAutoAssignSeat" 
                 className="focusClass btn btn-red OrangeShadow"
  
                 onClick={fncPopupCancelClick} onFocus={e => handleOnFocus(e)} >
                   No
                 </button>
               </Modal.Footer>
             </Modal>
       
       
             <Modal
               show={showErrorPopup}
               onHide={handleCloseshowErrorPopup}
               backdrop="static"
               keyboard={true}
               className="clsQuickAssign"
             >
               <Modal.Header>
                 <Modal.Title>Seat Assignment Failed</Modal.Title>
               </Modal.Header>
               <Modal.Body >
                 The time limit for seat assignment has been exceeded.
               </Modal.Body>
               <Modal.Footer>
                 <button  id='okbtnSeats' tabIndex={1} ref={okbutton} className="focusClass btn btn-red OrangeShadow" onClick={handleCloseshowErrorPopup}>
                   OK
                 </button>
               </Modal.Footer>
             </Modal>
       
             <Modal
               show={showSSRSeatNotAvailableErrorPopup}
               onHide={handleSSRSeatNotAvailableErrorPopup}
               backdrop="static"
               keyboard={true}
               className="clsQuickAssign"
             >
               <Modal.Header
                // closeButton
                >
                 <Modal.Title>Seat Assignment Failed</Modal.Title>
               </Modal.Header>
               <Modal.Body>
                 Cannot select this seat because an infant/wheelchair/UNMR passenger is already there in the same row.
               </Modal.Body>
               <Modal.Footer>
                 <button
                  ref={okbutton1}
                   className="focusClass btn btn-red" onClick={handleSSRSeatNotAvailableErrorPopup}>
                   OK
                 </button>
               </Modal.Footer>
             </Modal>
       {/* wavefee */}
             <Modal
               show={showWaiveFeeModal}
               onHide={handleCloseWaiveFeeModal}
               backdrop="static"
               keyboard={false}
               className="clsQuickAssign"
             >
               <Modal.Header 
              //  closeButton
               >
                 <Modal.Title>Waive Fee</Modal.Title>
               </Modal.Header>
               <Modal.Body>
                 <div class="row">
                   <div class="col-12">
                     <div class="col-12 mt-4 pt-2">
                       <div class="form-group sp-formField sp-selected">
                         <select  ref={waveReasonSelest} onChange={e => fncWaiveDropdownChange(e)} class="focusClass form-control" required>
                           <option id="">Select the Reason</option>
                           <option id="MAX" >MAX SEAT (MAX)</option>
                           <option id="COM">COMPLIMENTARY (COM)</option>
                           <option id="COR">COURTESY (COR)</option>
                           <option id="SVC">SERVICE RECOVERY (SVC)</option>
                           <option id="OTH">OTHER (OTH)</option>
                         </select>
                         <span class="label">Reason</span>
                       </div>
                     </div>
                     {
                       ShowWaveTextBox ?
                         <div class="col-12 mt-4">
                           <div class="form-group sp-formField sp-selected">
                             <input class="focusClass form-control" required type="text" value={WaveReasonTextBox} onChange={(e) => { fncWaveReason(e) }} />
                             <span class="label">Reason</span>
                           </div>
                         </div> : ""
                     }
                     <div class="col-12">
                       <div class="row font-semiBold text-color-black font-size-16">
                         <div class="col">Total</div>
                         <div class="col text-right">0.00 {SearchedFlightDetails.currencyCode}</div>
                       </div>
                     </div>
                     <div class="col-12 mt-4 d-flex">
                       <button type="button" class=" adjust focusClass btn btn-red-holo d-block  text-uppercase mr-2 OrangeShadow" disabled={waveOK} onClick={() => fncOverrideAmount("WA")} >OK</button>
                       <button type="button" id="waveNoBtn"  class="focusClass btn btn-red-holo  d-block  text-uppercase ml-2 OrangeShadow" onClick={handleCloseWaiveFeeModal} >CANCEL</button>
                     </div>
                   </div>
                 </div>
               </Modal.Body>
             </Modal>
             { /** ------------------------------ Modals end here ------------------------------ */}
       
             {/* ------------------------------- new ui details and legends starts from here ------------------------------- */}
             {/* <FocusTrap> */}
        <div class="seat-container">
               <div class="row">
                 <div class="col-lg-8">
                   <div class="leftDetail-data">
                     <div class="pTable-data-outer"> 
                       <div class="heading checkbox-input"   ref={seg_Unassign_jumpref}
                                       tabIndex={-1}
                                       style={{
                                        backgroundColor:"#ffffff",
                                       }}                  
                                      onKeyDown={(e) => {
                                       handleKeyDown(e);
                                       trapFocus1(e,seg_Unassign_jumpref); 
                                     }}
                       >
                         <h4 class="font-xxl bold dark-text mb-0">
                           Seat Assignments
                           {SearchedFlightDetails.journeys.map((jou, j) =>
                           jou.segments.map((seg, i) =>
                             seg.IsSelected == true ?
                               <span id={seg.segmentKey}>
                                 <button
                                   class={st_SelectedSeatByPassenger.segmentKey === seg.segmentKey ? "btn btn-primary ms-3 btn-animation SerachBtn" : "btn btn-primary-dark ms-3 SerachBtn"}
                                   onClick={() => jou.segments.length > 1 ? loadSeatmapForSegment(seg.segmentKey) : ""}
                                 > {/* btn btn-primary-dark */}
                                   {/* {(jou.segments.length > 1 && i==0 || jou.segments.length === 0) ? "btn btn-primary": "btn btn-primary-dark"} */}
                                   {seg.designator.destination}
                                 </button>
                               </span>
                               : ""
                           )
                         )}
                         </h4>
                         <div class="right-actions">
                           <div class="jumpSeat me-3">
                             <input
                               class="me-2 form-check-input OrangeShadow "
                               type="checkbox"
                               checked={jumpSeat}
                               onChange={(e) => { selectJumpSeat(e) }}
                               id="jumpSeat"
                               name="jumpSeat"
                               disabled={jumpSeatDisabled}
                             />
                             <label class="focusClass font-md grey-text mb-0">Jump Seat</label>
                           </div>
                           <button class="btn btn-primary btn-animation SerachBtn" disabled={st_UnAssignAll} 
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            e.stopPropagation();
                            fncUnAssignAllSeats();
                          }
                        }}
                         onClick={(e) => {
                        fncUnAssignAllSeats(); 
                        }}>Un-Assign All</button>
                         </div>
                       </div>
                       <div class="pTable border-t-1">
                         <div class="ptable-data">
                           <div class="headings">
                             <div class="name">Name</div>
                             <div class="gender">Gender</div>
                             <div class="seatNo">Seat No.</div>
                             <div class="seatClass">Seat Class</div>
                             <div class="seatFee">Seat Fee</div>
                             <div class="waiveFee">Waive Seat Fee</div>
                             <div class="type">Type</div>
                             <div class="action">Seat Assign</div>
                           </div>
                           <div class="pTable-scroll-body focusclass" ref={leftDivRef}  tabIndex={-1}>
                             {
                               st_UserSeatDetails.length > 0 ? st_UserSeatDetails.map((passenger,index) => 
                                 <div class={`checkbox-input ${passenger.SelectedPassenger ? "active table-item" : "table-item"}`} key={passenger.PassengerKey} ref={(el) => (inputElementForSeat.current[index] = el)} tabIndex={-1} 
                                    onKeyDown={(e) => {
                                     
                                         handleKeyDown(e, passenger.PassengerKey,"seatRows"); 
                                          if (activeleftChildIndex === index) { 
                                             trapFocus4(e, index,inputElementForSeat);
                                               }   
                                         }  }                                                             
                                 style={{
                                         backgroundColor: passenger.SelectedPassenger   ? "#f0f8ff" : "#ffffff",
                                        }}>
                                   <div class="name">
                                     <label>Name</label>
                                     <p>{passenger.PassengerName}</p>
                                   </div>
                                   <div class="gender">
                                     <label>Gender</label>
                                     <p> {passenger.PassengerGender}</p>
                                   </div>
                                   <div class="seatNo"> <label>Seat No.</label>
                   
                                     <input type="text" 
                                        id="seatnumber"
                                        disabled={!passenger.SelectedPassenger} 
                                        // onChange={(e) => { fncOnSeatchange(e) }} 
                                        onChange={(e) => { fncOnSeatchange(e,passenger) }} 
                                        value={passenger.SEATDETAIL ? passenger.SEATDETAIL :""}
                                          class="form-control primary-text" />                                
                                           {/* <p><span class="primary-text">{passenger.SEATDETAIL ? passenger.SEATDETAIL : '--'}</span></p> */}
                                     </div>                                            
                                   <div class="seatClass"> <label>Seat Class</label>
                                     <p>{passenger.SeatClass}</p>
                                   </div>
                                   <div class="seatFee"> <label>Seat Fee</label>
                                     <p>{SearchedFlightDetails.currencyCode} {passenger.Amount ? passenger.Amount : '0'}</p>
                                   </div>
                                   {/* <div class="focusClass waiveFee">
                                     {passenger.SelectedPassenger && passenger.Amount > 0 ?
                                       <img src="newImages/icon-fee.svg" alt="icon" onClick={() => openWaiveFeeModal(passenger.PassengerKey)} /> : null
                                     }
                                   </div> */}
                                   {/* update */}
                                 <div   className="waiveFee"
                                   role="button"                       
         >
                                  {passenger.SelectedPassenger && passenger.Amount > 0 ?
                                   (
                                      <img 
                                       tabIndex={0}
                                        src="newImages/icon-fee.svg"   alt="icon"  
                                         onKeyDown={(e) => {
                                         if (e.key === "Enter" || e.key === " "){
                                          openWaiveFeeModal(passenger.PassengerKey);
                                         }
                                         }}
                                        onClick={() => openWaiveFeeModal(passenger.PassengerKey)} />
                                   ) : null}
                                 </div>
       
                                   <div class="type"><label>Type</label>
                                     <p>{passenger.PassengerTypeCode}</p>
                                   </div>
       
                                   {SearchedFlightDetails.journeys.map((jou, j) =>
                                     jou.segments.filter(s => s.segmentKey === st_SelectedSeatByPassenger.segmentKey).map((seg, i) =>
                                       seg.passengerSegment.map((paxseg) =>
                                         paxseg.passengerKey == passenger.PassengerKey && paxseg.IsSelected == true ?
                                           <div class="action">
                                             <a class="change-seat" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#selectSeat">{passenger.SEATDETAIL ? 'Change Seat' : 'Add Seat'}</a>
                                             <input class="focusClass me-2 form-check-input checkbox-input"
                                               type="checkbox"
                                               // tabIndex={-1}
                                               checked={passenger.SelectedPassenger}
                                               onChange={() => { fncLoadSeatMapWithDetails(seg.segmentKey, passenger.PassengerKey, jou.journeyKey, SearchedFlightDetails.recordLocator, SearchedFlightDetails.currencyCode, paxseg.seats.length == 0 ? "" : paxseg.seats[0].unitDesignator)
                                                }}
                                               id={seg.segmentKey + "!!" + paxseg.passengerKey}
                                             />
                                           </div> : ""
                                       )
                                     )
                                   )}
                                 </div>
                               ) : null
                             }
                           </div>
                         </div>
                       </div>
                       { /**-----------seatmap legends---------------------------- */}
                       <div class="heading mt-4">
                         <h4 class="font-md bold dark-text mb-0">
                           Seat Map Legends
                                       </h4>
                       </div>
                       <div class="seatMap">
                         <div class="seatMap-item">
                           <div class="seat-icon">
                             <img src="newImages/seat-max.svg" />
                           </div>
                           <p class="font-xs mb-0">Max Seat</p>
                         </div>
                         <div class="seatMap-item">
                           <div class="seat-icon">
                             <img src="newImages/seat-normal.svg" />
                           </div>
                           <p class="font-xs mb-0">Normal Seat</p>
                         </div>
                         <div class="seatMap-item">
                           <div class="seat-icon">
                             <img src="newImages/seat-reserved.svg" />
                           </div>
                           <p class="font-xs mb-0">Reserved Seat</p>
                         </div>
                         <div class="seatMap-item">
                           <div class="seat-icon">
                             <img src="newImages/seat-hold.svg" />
                           </div>
                           <p class="font-xs mb-0">Held by Agent</p>
                         </div>
                         <div class="seatMap-item">
                           <div class="seat-icon">
                             <img src="newImages/seat-block.svg" />
                           </div>
                           <p class="font-xs mb-0">Block And Unavailable</p>
                         </div>
                         <div class="seatMap-item">
                           <div class="seat-icon">
                             <img src="newImages/seat-inoperable.svg" />
                           </div>
                           <p class="font-xs mb-0">Inoperable</p>
                         </div>
                         <div class="seatMap-item">
                           <div class="seat-icon">
                             <img src="newImages/seat-checked-in.svg" />
                           </div>
                           <p class="font-xs mb-0">Checked In</p>
                         </div>
                       </div>
                       { /**-----------seatmap legends---------------------------- */}
                     </div>
                   </div>
                 </div>
                 <div class="col-lg-4 d-none d-lg-block">
                   <div class="rightDetail-data ">
                   <ol class={st_countOfRowsFormed.length > 0 && (st_countOfRowsFormed[0].dataToBind.length === 4 ? "cabin fuselage seat2-2" : st_countOfRowsFormed[0].dataToBind.length === 3 ? "cabin fuselage seat1-2" : "cabin fuselage")}>
                       <li class="row row--1 marks">
                         <ol class="seats" type="A">
                           <li></li>
                           {st_AirlineHeader.length == 0 ? '' :
                             st_AirlineHeader.map((data, i) =>
                               <li class="seat" key={`header-${data.SeatDesignator || i}`}>
                                 {<p>{data.SeatDesignator}</p>}
                               </li>
                             )}
                         </ol>
                       </li>
                       {
                         st_countOfRowsFormed.length == 0 ? '' :
                           st_countOfRowsFormed.map((data, i) =>
                             <li class={`row row--${data.id} checkbox-input`} id={`seatRow-${data.id}`} 
                           key={data.id}
                          ref={(el) => (rightSeatsDivRef.current[i] = el)}
                          tabIndex={-1} 
                               onKeyDown={(e) => {
                            handleKeyDown(e, data.id,"seatRows"); 
                           if (activeIndex === i) {
                              trapFocus3(e, i,rightSeatsDivRef); 
                           }
                   }}
                    style={{
                     outline: activeIndex === i ? "2px #f0f8ff" : "none",
                     backgroundColor: activeIndex === i? "#f0f8ff" : "#ffffff",
                     }}  >  
                               <ol class="seats" type="A">
                                 <li>{data.id}.</li>
                                 {
                                 data.dataToBind.map((SeatData, j) => (
                                   <li
                                     className="seat"  y={SeatData.Y}
                                     tabIndex={-1}
                                     key={j}                            
                                       >
                                     {SeatData.Status === "Open" ? (
                                       <div 
                                       tabIndex={-1}                        
                                       >
                                        
                                         <input
                                           className={SeatData.Y === 1 ? "maxseat focusClass" : "focusClass"}
                                           status={SeatData.Status}
                                           type="checkbox"
                                           tabIndex={-1}
                                                      />
                                         <label                                    
                   onKeyDown={(e) => {
                                            // e.stopPropagation();
                                            handleKeyDown(e);
                                             if (e.key === "Enter") {
                                               e.stopPropagation();
                                              fncSeatSelection(SeatData, "SEATMAP", data.id); 
                                            }
                                          }}
                                           onClick={() => fncSeatSelection(SeatData, "SEATMAP", data.id)}
                                           tabIndex={0} 
                                         >
                                           {SeatData.SeatDesignator ? SeatData.SeatDesignator : ""}
                                         </label>
                                       </div>
                                     ) : SeatData.Status === "HeldForAnotherSession" ? (
                                       <div>{ssrsOnOtherSeats(SeatData)}</div>
                                     ) : SeatData.Status === "ReservedForPnr" ? (
                                       <div>{elementReservedForPnr(SeatData, data)}</div>
                                     ) : SeatData.Status === "HeldForThisSession" ? (
                                       <div>
                                         {st_UserSeatDetails.length === 0
                                           ? ""
                                           : st_UserSeatDetails.map((data, i) =>
                                               SeatData.SeatDesignator === data.SEATDETAIL ? (
                                                 <div key={i}>
                                                   <input
                                                     className={classForHeldForThisSession(SeatData, data)}
                                                     status={SeatData.Status}
                                                     type="checkbox"
                                                     tabIndex={-1}
                                                   />
                                                   <label
                                                     style={
                                                       data.SelectedPassenger ? { backgroundColor: "green" } : {}
                                                     }
                                                     tabIndex={-1}
                                                   >
                                                     {SeatData.SeatDesignator ? SeatData.SeatDesignator : ""}
                                                   </label>
                                                 </div>
                                               ) : (
                                                 ""
                                               )
                                             )}
                                       </div>
                                     ) : SeatData.Status === "Blocked" || SeatData.Status === "Unavailable" ? (
                                       <div>
                                         <input
                                           className={SeatData.Y === 1 ? "maxseat blocked" : "blocked"}
                                           type="checkbox"
                                           tabIndex={-1}
                                         />
                                         <label tabIndex={-1}>
                                           {SeatData.SeatDesignator ? SeatData.SeatDesignator : ""}
                                         </label>
                                       </div>
                                     ) : SeatData.Status === "Broken" ? (
                                       <div>
                                         <input
                                           className={SeatData.Y === 1 ? "maxseat borkenSeat" : "borkenSeat"}
                                           type="checkbox"
                                           tabIndex={-1}
                                         />
                                         <label tabIndex={-1}>
                                           {SeatData.SeatDesignator ? SeatData.SeatDesignator : ""}
                                         </label>
                                       </div>
                                     ) : SeatData.Status === "CheckedIn" ? (
                                       <div>
                                         <input
                                           type="checkbox"
                                           className={classForCheckedIn(SeatData)}
                                           tabIndex={-1}
                                         />
                                         <label tabIndex={-1}>
                                           {SeatData.SeatDesignator ? SeatData.SeatDesignator : ""}
                                         </label>
                                       </div>
                                     ) : SeatData.Status === "Reserved" ? (
                                       <div>{ssrsOnOtherSeats(SeatData)}</div>
                                     ) : SeatData.Status === "0" ? (
                                       ""
                                     ) : (
                                       ""
                                     )}
                                   </li>
                                 ))                         
                                                    
                                 }
                               </ol>
                             </li>
                           )
                       }
                     </ol>
                   </div>
                 </div>
               </div>
               <div class="btn-container" tabIndex={-1}>
                 <a class="btn btn-primary-dark btn-animation" onClick={() => history.goBack()} 
                  >
                   <span class="px-4"><span class="icon me-2"><img class=" rotate180" src="newImages/i-arrow-right.svg" /> <img class=" rotate180" src="newImages/i-arrow-right.svg" /></span>Previous</span>
                 </a>
                 <a class="btn btn-secondary btn-animation" id="btnNextButtonSeat" onClick={()=>fncNextSeat()} 
                  
                  >
                   <span class="px-4"> Next<span class="icon ms-2"><img src="newImages/i-arrow-right.svg" /> <img src="newImages/i-arrow-right.svg" /></span></span>
                 </a>
               </div>
              
             </div>
              {/* </FocusTrap> */}
             {/* ------------------------------- new ui details and legends ends here ------------------------------- */}
             {/** mobile view seatmap */}
             <div class="modal fade " id="selectSeat"  aria-labelledby="staticBackdropLabel" aria-hidden="true" data-bs-backdrop="static" data-dismiss="modal" data-toggle="modal">
               <div class="modal-dialog modal-dialog-centered seat-modal">
                 <div class="modal-content">
                   <div class="heading">
                     <a data-bs-dismiss="modal" class="modal-close">
                       <img src="newImages/i-cross.svg" alt="cross" />
                     </a>
                     <h4 class="font-xxl mb-0"> Select Your Seat</h4>
                   </div>
                   <div class="select-seat-content">                    
                            <ol class={st_countOfRowsFormed.length > 0 && (st_countOfRowsFormed[0].dataToBind.length === 4 ? "cabin fuselage seat2-2" : st_countOfRowsFormed[0].dataToBind.length === 3 ? "cabin fuselage seat1-2" : "cabin fuselage")}>
                       <li class="row row--1 marks">
                         <ol class="seats" type="A">
                           <li></li>              
                           {st_AirlineHeader.length == 0 ? '' :
                             st_AirlineHeader.map((data, i) =>
                            <li class="seat" key={`header-${data.SeatDesignator || i}`}>
                                 {<p>{data.SeatDesignator}</p>}
                               </li>
                             )}
                         </ol>
                       </li>
                       {
                         st_countOfRowsFormed.length == 0 ? '' :
                           st_countOfRowsFormed.map((data, i) =>
                             <li class={`row row--${data.id}`} id={`seatRow-${data.id}`} >
                                          <ol class="seats" type="A">
                                 <li>{data.id}.</li>
                                 {
       
                                   data.dataToBind.map((SeatData, j) =>
                                     <li class="seat" y={SeatData.Y}>
                                       {
                                         SeatData.Status == "Open" ?
                                           <div >
                                             <input class={SeatData.Y == 1 ? "maxseat" : ""} status={SeatData.Status} type="checkbox" />
                                             <label onClick={() => { fncSeatSelection(SeatData, "SEATMAP", data.id) }}>{SeatData.SeatDesignator ? SeatData.SeatDesignator : ""}</label>
                                           </div>
                                           : SeatData.Status == "HeldForAnotherSession" ?
                                             <div> {ssrsOnOtherSeats(SeatData)} </div>
                                             : SeatData.Status == "ReservedForPnr" ?
                                               <div> {elementReservedForPnr(SeatData, data)}</div>
                                               : SeatData.Status == "HeldForThisSession" ?
                                                 <div>
       
                                                   {
                                                     st_UserSeatDetails.length == 0 ? "" : st_UserSeatDetails.map((data, i) => SeatData.SeatDesignator == data.SEATDETAIL ?
                                                       <div>
                                                         <input
                                                           class=
                                                           {
                                                             classForHeldForThisSession(SeatData, data)
                                                           }
                                                           status={SeatData.Status}
                                                           type="checkbox"
                                                         />
                                                         <label style={data.SelectedPassenger == true ? { "backgroundColor": "green" } : { "": "" }}>{SeatData.SeatDesignator ? SeatData.SeatDesignator : ""}</label>
                                                       </div>
                                                       : ""
                                                     )
                                                   }
                                                 </div>
                                                 : SeatData.Status == "Blocked" || SeatData.Status == "Unavailable" ?
                                                   <div>
                                                     <input class={SeatData.Y == 1 ? "maxseat blocked" : "blocked"} type="checkbox" />
                                                     <label>{SeatData.SeatDesignator ? SeatData.SeatDesignator : ""}</label>
                                                   </div>
                                                   : SeatData.Status == "Broken" ?
                                                     <div>
                                                       <input class={SeatData.Y == 1 ? "maxseat borkenSeat" : "borkenSeat"} type="checkbox" />
                                                       <label>{SeatData.SeatDesignator ? SeatData.SeatDesignator : ""}</label>
                                                     </div>
                                                     : SeatData.Status == "CheckedIn" ?
                                                       <div>
                                                         <div>
                                                           <input
                                                             type="checkbox"
                                                             class={classForCheckedIn(SeatData)}
                                                           />
                                                           <label style={data.SelectedPassenger == true ? { "backgroundColor": "green" } : { "": "" }}>{SeatData.SeatDesignator ? SeatData.SeatDesignator : ""}</label>
                                                         </div>
                                                       </div>
                                                       : SeatData.Status == "Reserved" ?
                                                         <div>{ssrsOnOtherSeats(SeatData)}</div>
                                                         : SeatData.Status == "0" ?
                                                           ""
                                                           :
                                                           ""
                                       }
                                     </li>
                                   )
                                 }
                               </ol>
                             </li>
                           )
                       }
                     </ol>
                   </div>
                   <div class="btn-container">
                     <a data-bs-dismiss="modal" class="btn btn-primary-dark">
                       <span class="px-4">Close</span>
                     </a>
                   </div>
                 </div>
               </div>
             </div>
           </div>
       
         );
       }

export default Seats;
